export const FontAwesome = [
  {
    "name": "500px",
    "icon": "fa-500px fab"
  },
  {
    "name": "accessible-icon",
    "icon": "fa-accessible-icon fab"
  },
  {
    "name": "accusoft",
    "icon": "fa-accusoft fab"
  },
  {
    "name": "acquisitions-incorporated",
    "icon": "fa-acquisitions-incorporated fab"
  },
  {
    "name": "ad",
    "icon": "fa-ad fas"
  },
  {
    "name": "address-book",
    "icon": "fa-address-book fas"
  },
  {
    "name": "address-card",
    "icon": "fa-address-card fas"
  },
  {
    "name": "adjust",
    "icon": "fa-adjust fas"
  },
  {
    "name": "adn",
    "icon": "fa-adn fab"
  },
  {
    "name": "adversal",
    "icon": "fa-adversal fab"
  },
  {
    "name": "affiliatetheme",
    "icon": "fa-affiliatetheme fab"
  },
  {
    "name": "air-freshener",
    "icon": "fa-air-freshener fas"
  },
  {
    "name": "airbnb",
    "icon": "fa-airbnb fab"
  },
  {
    "name": "algolia",
    "icon": "fa-algolia fab"
  },
  {
    "name": "align-center",
    "icon": "fa-align-center fas"
  },
  {
    "name": "align-justify",
    "icon": "fa-align-justify fas"
  },
  {
    "name": "align-left",
    "icon": "fa-align-left fas"
  },
  {
    "name": "align-right",
    "icon": "fa-align-right fas"
  },
  {
    "name": "alipay",
    "icon": "fa-alipay fab"
  },
  {
    "name": "allergies",
    "icon": "fa-allergies fas"
  },
  {
    "name": "amazon",
    "icon": "fa-amazon fab"
  },
  {
    "name": "amazon-pay",
    "icon": "fa-amazon-pay fab"
  },
  {
    "name": "ambulance",
    "icon": "fa-ambulance fas"
  },
  {
    "name": "american-sign-language-interpreting",
    "icon": "fa-american-sign-language-interpreting fas"
  },
  {
    "name": "amilia",
    "icon": "fa-amilia fab"
  },
  {
    "name": "anchor",
    "icon": "fa-anchor fas"
  },
  {
    "name": "android",
    "icon": "fa-android fab"
  },
  {
    "name": "angellist",
    "icon": "fa-angellist fab"
  },
  {
    "name": "angle-double-down",
    "icon": "fa-angle-double-down fas"
  },
  {
    "name": "angle-double-left",
    "icon": "fa-angle-double-left fas"
  },
  {
    "name": "angle-double-right",
    "icon": "fa-angle-double-right fas"
  },
  {
    "name": "angle-double-up",
    "icon": "fa-angle-double-up fas"
  },
  {
    "name": "angle-down",
    "icon": "fa-angle-down fas"
  },
  {
    "name": "angle-left",
    "icon": "fa-angle-left fas"
  },
  {
    "name": "angle-right",
    "icon": "fa-angle-right fas"
  },
  {
    "name": "angle-up",
    "icon": "fa-angle-up fas"
  },
  {
    "name": "angry",
    "icon": "fa-angry fas"
  },
  {
    "name": "angrycreative",
    "icon": "fa-angrycreative fab"
  },
  {
    "name": "angular",
    "icon": "fa-angular fab"
  },
  {
    "name": "ankh",
    "icon": "fa-ankh fas"
  },
  {
    "name": "app-store",
    "icon": "fa-app-store fab"
  },
  {
    "name": "app-store-ios",
    "icon": "fa-app-store-ios fab"
  },
  {
    "name": "apper",
    "icon": "fa-apper fab"
  },
  {
    "name": "apple",
    "icon": "fa-apple fab"
  },
  {
    "name": "apple-alt",
    "icon": "fa-apple-alt fas"
  },
  {
    "name": "apple-pay",
    "icon": "fa-apple-pay fab"
  },
  {
    "name": "archive",
    "icon": "fa-archive fas"
  },
  {
    "name": "archway",
    "icon": "fa-archway fas"
  },
  {
    "name": "arrow-alt-circle-down",
    "icon": "fa-arrow-alt-circle-down fas"
  },
  {
    "name": "arrow-alt-circle-left",
    "icon": "fa-arrow-alt-circle-left fas"
  },
  {
    "name": "arrow-alt-circle-right",
    "icon": "fa-arrow-alt-circle-right fas"
  },
  {
    "name": "arrow-alt-circle-up",
    "icon": "fa-arrow-alt-circle-up fas"
  },
  {
    "name": "arrow-circle-down",
    "icon": "fa-arrow-circle-down fas"
  },
  {
    "name": "arrow-circle-left",
    "icon": "fa-arrow-circle-left fas"
  },
  {
    "name": "arrow-circle-right",
    "icon": "fa-arrow-circle-right fas"
  },
  {
    "name": "arrow-circle-up",
    "icon": "fa-arrow-circle-up fas"
  },
  {
    "name": "arrow-down",
    "icon": "fa-arrow-down fas"
  },
  {
    "name": "arrow-left",
    "icon": "fa-arrow-left fas"
  },
  {
    "name": "arrow-right",
    "icon": "fa-arrow-right fas"
  },
  {
    "name": "arrow-up",
    "icon": "fa-arrow-up fas"
  },
  {
    "name": "arrows-alt",
    "icon": "fa-arrows-alt fas"
  },
  {
    "name": "arrows-alt-h",
    "icon": "fa-arrows-alt-h fas"
  },
  {
    "name": "arrows-alt-v",
    "icon": "fa-arrows-alt-v fas"
  },
  {
    "name": "artstation",
    "icon": "fa-artstation fab"
  },
  {
    "name": "assistive-listening-systems",
    "icon": "fa-assistive-listening-systems fas"
  },
  {
    "name": "asterisk",
    "icon": "fa-asterisk fas"
  },
  {
    "name": "asymmetrik",
    "icon": "fa-asymmetrik fab"
  },
  {
    "name": "at",
    "icon": "fa-at fas"
  },
  {
    "name": "atlas",
    "icon": "fa-atlas fas"
  },
  {
    "name": "atlassian",
    "icon": "fa-atlassian fab"
  },
  {
    "name": "atom",
    "icon": "fa-atom fas"
  },
  {
    "name": "audible",
    "icon": "fa-audible fab"
  },
  {
    "name": "audio-description",
    "icon": "fa-audio-description fas"
  },
  {
    "name": "autoprefixer",
    "icon": "fa-autoprefixer fab"
  },
  {
    "name": "avianex",
    "icon": "fa-avianex fab"
  },
  {
    "name": "aviato",
    "icon": "fa-aviato fab"
  },
  {
    "name": "award",
    "icon": "fa-award fas"
  },
  {
    "name": "aws",
    "icon": "fa-aws fab"
  },
  {
    "name": "baby",
    "icon": "fa-baby fas"
  },
  {
    "name": "baby-carriage",
    "icon": "fa-baby-carriage fas"
  },
  {
    "name": "backspace",
    "icon": "fa-backspace fas"
  },
  {
    "name": "backward",
    "icon": "fa-backward fas"
  },
  {
    "name": "bacon",
    "icon": "fa-bacon fas"
  },
  {
    "name": "bacteria",
    "icon": "fa-bacteria fas"
  },
  {
    "name": "bacterium",
    "icon": "fa-bacterium fas"
  },
  {
    "name": "bahai",
    "icon": "fa-bahai fas"
  },
  {
    "name": "balance-scale",
    "icon": "fa-balance-scale fas"
  },
  {
    "name": "balance-scale-left",
    "icon": "fa-balance-scale-left fas"
  },
  {
    "name": "balance-scale-right",
    "icon": "fa-balance-scale-right fas"
  },
  {
    "name": "ban",
    "icon": "fa-ban fas"
  },
  {
    "name": "band-aid",
    "icon": "fa-band-aid fas"
  },
  {
    "name": "bandcamp",
    "icon": "fa-bandcamp fab"
  },
  {
    "name": "barcode",
    "icon": "fa-barcode fas"
  },
  {
    "name": "bars",
    "icon": "fa-bars fas"
  },
  {
    "name": "baseball-ball",
    "icon": "fa-baseball-ball fas"
  },
  {
    "name": "basketball-ball",
    "icon": "fa-basketball-ball fas"
  },
  {
    "name": "bath",
    "icon": "fa-bath fas"
  },
  {
    "name": "battery-empty",
    "icon": "fa-battery-empty fas"
  },
  {
    "name": "battery-full",
    "icon": "fa-battery-full fas"
  },
  {
    "name": "battery-half",
    "icon": "fa-battery-half fas"
  },
  {
    "name": "battery-quarter",
    "icon": "fa-battery-quarter fas"
  },
  {
    "name": "battery-three-quarters",
    "icon": "fa-battery-three-quarters fas"
  },
  {
    "name": "battle-net",
    "icon": "fa-battle-net fab"
  },
  {
    "name": "bed",
    "icon": "fa-bed fas"
  },
  {
    "name": "beer",
    "icon": "fa-beer fas"
  },
  {
    "name": "behance",
    "icon": "fa-behance fab"
  },
  {
    "name": "behance-square",
    "icon": "fa-behance-square fab"
  },
  {
    "name": "bell",
    "icon": "fa-bell fas"
  },
  {
    "name": "bell-slash",
    "icon": "fa-bell-slash fas"
  },
  {
    "name": "bezier-curve",
    "icon": "fa-bezier-curve fas"
  },
  {
    "name": "bible",
    "icon": "fa-bible fas"
  },
  {
    "name": "bicycle",
    "icon": "fa-bicycle fas"
  },
  {
    "name": "biking",
    "icon": "fa-biking fas"
  },
  {
    "name": "bimobject",
    "icon": "fa-bimobject fab"
  },
  {
    "name": "binoculars",
    "icon": "fa-binoculars fas"
  },
  {
    "name": "biohazard",
    "icon": "fa-biohazard fas"
  },
  {
    "name": "birthday-cake",
    "icon": "fa-birthday-cake fas"
  },
  {
    "name": "bitbucket",
    "icon": "fa-bitbucket fab"
  },
  {
    "name": "bitcoin",
    "icon": "fa-bitcoin fab"
  },
  {
    "name": "bity",
    "icon": "fa-bity fab"
  },
  {
    "name": "black-tie",
    "icon": "fa-black-tie fab"
  },
  {
    "name": "blackberry",
    "icon": "fa-blackberry fab"
  },
  {
    "name": "blender",
    "icon": "fa-blender fas"
  },
  {
    "name": "blender-phone",
    "icon": "fa-blender-phone fas"
  },
  {
    "name": "blind",
    "icon": "fa-blind fas"
  },
  {
    "name": "blog",
    "icon": "fa-blog fas"
  },
  {
    "name": "blogger",
    "icon": "fa-blogger fab"
  },
  {
    "name": "blogger-b",
    "icon": "fa-blogger-b fab"
  },
  {
    "name": "bluetooth",
    "icon": "fa-bluetooth fab"
  },
  {
    "name": "bluetooth-b",
    "icon": "fa-bluetooth-b fab"
  },
  {
    "name": "bold",
    "icon": "fa-bold fas"
  },
  {
    "name": "bolt",
    "icon": "fa-bolt fas"
  },
  {
    "name": "bomb",
    "icon": "fa-bomb fas"
  },
  {
    "name": "bone",
    "icon": "fa-bone fas"
  },
  {
    "name": "bong",
    "icon": "fa-bong fas"
  },
  {
    "name": "book",
    "icon": "fa-book fas"
  },
  {
    "name": "book-dead",
    "icon": "fa-book-dead fas"
  },
  {
    "name": "book-medical",
    "icon": "fa-book-medical fas"
  },
  {
    "name": "book-open",
    "icon": "fa-book-open fas"
  },
  {
    "name": "book-reader",
    "icon": "fa-book-reader fas"
  },
  {
    "name": "bookmark",
    "icon": "fa-bookmark fas"
  },
  {
    "name": "bootstrap",
    "icon": "fa-bootstrap fab"
  },
  {
    "name": "border-all",
    "icon": "fa-border-all fas"
  },
  {
    "name": "border-none",
    "icon": "fa-border-none fas"
  },
  {
    "name": "border-style",
    "icon": "fa-border-style fas"
  },
  {
    "name": "bowling-ball",
    "icon": "fa-bowling-ball fas"
  },
  {
    "name": "box",
    "icon": "fa-box fas"
  },
  {
    "name": "box-open",
    "icon": "fa-box-open fas"
  },
  {
    "name": "box-tissue",
    "icon": "fa-box-tissue fas"
  },
  {
    "name": "boxes",
    "icon": "fa-boxes fas"
  },
  {
    "name": "braille",
    "icon": "fa-braille fas"
  },
  {
    "name": "brain",
    "icon": "fa-brain fas"
  },
  {
    "name": "bread-slice",
    "icon": "fa-bread-slice fas"
  },
  {
    "name": "briefcase",
    "icon": "fa-briefcase fas"
  },
  {
    "name": "briefcase-medical",
    "icon": "fa-briefcase-medical fas"
  },
  {
    "name": "broadcast-tower",
    "icon": "fa-broadcast-tower fas"
  },
  {
    "name": "broom",
    "icon": "fa-broom fas"
  },
  {
    "name": "brush",
    "icon": "fa-brush fas"
  },
  {
    "name": "btc",
    "icon": "fa-btc fab"
  },
  {
    "name": "buffer",
    "icon": "fa-buffer fab"
  },
  {
    "name": "bug",
    "icon": "fa-bug fas"
  },
  {
    "name": "building",
    "icon": "fa-building fas"
  },
  {
    "name": "bullhorn",
    "icon": "fa-bullhorn fas"
  },
  {
    "name": "bullseye",
    "icon": "fa-bullseye fas"
  },
  {
    "name": "burn",
    "icon": "fa-burn fas"
  },
  {
    "name": "buromobelexperte",
    "icon": "fa-buromobelexperte fab"
  },
  {
    "name": "bus",
    "icon": "fa-bus fas"
  },
  {
    "name": "bus-alt",
    "icon": "fa-bus-alt fas"
  },
  {
    "name": "business-time",
    "icon": "fa-business-time fas"
  },
  {
    "name": "buy-n-large",
    "icon": "fa-buy-n-large fab"
  },
  {
    "name": "buysellads",
    "icon": "fa-buysellads fab"
  },
  {
    "name": "calculator",
    "icon": "fa-calculator fas"
  },
  {
    "name": "calendar",
    "icon": "fa-calendar fas"
  },
  {
    "name": "calendar-alt",
    "icon": "fa-calendar-alt fas"
  },
  {
    "name": "calendar-check",
    "icon": "fa-calendar-check fas"
  },
  {
    "name": "calendar-day",
    "icon": "fa-calendar-day fas"
  },
  {
    "name": "calendar-minus",
    "icon": "fa-calendar-minus fas"
  },
  {
    "name": "calendar-plus",
    "icon": "fa-calendar-plus fas"
  },
  {
    "name": "calendar-times",
    "icon": "fa-calendar-times fas"
  },
  {
    "name": "calendar-week",
    "icon": "fa-calendar-week fas"
  },
  {
    "name": "camera",
    "icon": "fa-camera fas"
  },
  {
    "name": "camera-retro",
    "icon": "fa-camera-retro fas"
  },
  {
    "name": "campground",
    "icon": "fa-campground fas"
  },
  {
    "name": "canadian-maple-leaf",
    "icon": "fa-canadian-maple-leaf fab"
  },
  {
    "name": "candy-cane",
    "icon": "fa-candy-cane fas"
  },
  {
    "name": "cannabis",
    "icon": "fa-cannabis fas"
  },
  {
    "name": "capsules",
    "icon": "fa-capsules fas"
  },
  {
    "name": "car",
    "icon": "fa-car fas"
  },
  {
    "name": "car-alt",
    "icon": "fa-car-alt fas"
  },
  {
    "name": "car-battery",
    "icon": "fa-car-battery fas"
  },
  {
    "name": "car-crash",
    "icon": "fa-car-crash fas"
  },
  {
    "name": "car-side",
    "icon": "fa-car-side fas"
  },
  {
    "name": "caravan",
    "icon": "fa-caravan fas"
  },
  {
    "name": "caret-down",
    "icon": "fa-caret-down fas"
  },
  {
    "name": "caret-left",
    "icon": "fa-caret-left fas"
  },
  {
    "name": "caret-right",
    "icon": "fa-caret-right fas"
  },
  {
    "name": "caret-square-down",
    "icon": "fa-caret-square-down fas"
  },
  {
    "name": "caret-square-left",
    "icon": "fa-caret-square-left fas"
  },
  {
    "name": "caret-square-right",
    "icon": "fa-caret-square-right fas"
  },
  {
    "name": "caret-square-up",
    "icon": "fa-caret-square-up fas"
  },
  {
    "name": "caret-up",
    "icon": "fa-caret-up fas"
  },
  {
    "name": "carrot",
    "icon": "fa-carrot fas"
  },
  {
    "name": "cart-arrow-down",
    "icon": "fa-cart-arrow-down fas"
  },
  {
    "name": "cart-plus",
    "icon": "fa-cart-plus fas"
  },
  {
    "name": "cash-register",
    "icon": "fa-cash-register fas"
  },
  {
    "name": "cat",
    "icon": "fa-cat fas"
  },
  {
    "name": "cc-amazon-pay",
    "icon": "fa-cc-amazon-pay fab"
  },
  {
    "name": "cc-amex",
    "icon": "fa-cc-amex fab"
  },
  {
    "name": "cc-apple-pay",
    "icon": "fa-cc-apple-pay fab"
  },
  {
    "name": "cc-diners-club",
    "icon": "fa-cc-diners-club fab"
  },
  {
    "name": "cc-discover",
    "icon": "fa-cc-discover fab"
  },
  {
    "name": "cc-jcb",
    "icon": "fa-cc-jcb fab"
  },
  {
    "name": "cc-mastercard",
    "icon": "fa-cc-mastercard fab"
  },
  {
    "name": "cc-paypal",
    "icon": "fa-cc-paypal fab"
  },
  {
    "name": "cc-stripe",
    "icon": "fa-cc-stripe fab"
  },
  {
    "name": "cc-visa",
    "icon": "fa-cc-visa fab"
  },
  {
    "name": "centercode",
    "icon": "fa-centercode fab"
  },
  {
    "name": "centos",
    "icon": "fa-centos fab"
  },
  {
    "name": "certificate",
    "icon": "fa-certificate fas"
  },
  {
    "name": "chair",
    "icon": "fa-chair fas"
  },
  {
    "name": "chalkboard",
    "icon": "fa-chalkboard fas"
  },
  {
    "name": "chalkboard-teacher",
    "icon": "fa-chalkboard-teacher fas"
  },
  {
    "name": "charging-station",
    "icon": "fa-charging-station fas"
  },
  {
    "name": "chart-area",
    "icon": "fa-chart-area fas"
  },
  {
    "name": "chart-bar",
    "icon": "fa-chart-bar fas"
  },
  {
    "name": "chart-line",
    "icon": "fa-chart-line fas"
  },
  {
    "name": "chart-pie",
    "icon": "fa-chart-pie fas"
  },
  {
    "name": "check",
    "icon": "fa-check fas"
  },
  {
    "name": "check-circle",
    "icon": "fa-check-circle fas"
  },
  {
    "name": "check-double",
    "icon": "fa-check-double fas"
  },
  {
    "name": "check-square",
    "icon": "fa-check-square fas"
  },
  {
    "name": "cheese",
    "icon": "fa-cheese fas"
  },
  {
    "name": "chess",
    "icon": "fa-chess fas"
  },
  {
    "name": "chess-bishop",
    "icon": "fa-chess-bishop fas"
  },
  {
    "name": "chess-board",
    "icon": "fa-chess-board fas"
  },
  {
    "name": "chess-king",
    "icon": "fa-chess-king fas"
  },
  {
    "name": "chess-knight",
    "icon": "fa-chess-knight fas"
  },
  {
    "name": "chess-pawn",
    "icon": "fa-chess-pawn fas"
  },
  {
    "name": "chess-queen",
    "icon": "fa-chess-queen fas"
  },
  {
    "name": "chess-rook",
    "icon": "fa-chess-rook fas"
  },
  {
    "name": "chevron-circle-down",
    "icon": "fa-chevron-circle-down fas"
  },
  {
    "name": "chevron-circle-left",
    "icon": "fa-chevron-circle-left fas"
  },
  {
    "name": "chevron-circle-right",
    "icon": "fa-chevron-circle-right fas"
  },
  {
    "name": "chevron-circle-up",
    "icon": "fa-chevron-circle-up fas"
  },
  {
    "name": "chevron-down",
    "icon": "fa-chevron-down fas"
  },
  {
    "name": "chevron-left",
    "icon": "fa-chevron-left fas"
  },
  {
    "name": "chevron-right",
    "icon": "fa-chevron-right fas"
  },
  {
    "name": "chevron-up",
    "icon": "fa-chevron-up fas"
  },
  {
    "name": "child",
    "icon": "fa-child fas"
  },
  {
    "name": "chrome",
    "icon": "fa-chrome fab"
  },
  {
    "name": "chromecast",
    "icon": "fa-chromecast fab"
  },
  {
    "name": "church",
    "icon": "fa-church fas"
  },
  {
    "name": "circle",
    "icon": "fa-circle fas"
  },
  {
    "name": "circle-notch",
    "icon": "fa-circle-notch fas"
  },
  {
    "name": "city",
    "icon": "fa-city fas"
  },
  {
    "name": "clinic-medical",
    "icon": "fa-clinic-medical fas"
  },
  {
    "name": "clipboard",
    "icon": "fa-clipboard fas"
  },
  {
    "name": "clipboard-check",
    "icon": "fa-clipboard-check fas"
  },
  {
    "name": "clipboard-list",
    "icon": "fa-clipboard-list fas"
  },
  {
    "name": "clock",
    "icon": "fa-clock fas"
  },
  {
    "name": "clone",
    "icon": "fa-clone fas"
  },
  {
    "name": "closed-captioning",
    "icon": "fa-closed-captioning fas"
  },
  {
    "name": "cloud",
    "icon": "fa-cloud fas"
  },
  {
    "name": "cloud-download-alt",
    "icon": "fa-cloud-download-alt fas"
  },
  {
    "name": "cloud-meatball",
    "icon": "fa-cloud-meatball fas"
  },
  {
    "name": "cloud-moon",
    "icon": "fa-cloud-moon fas"
  },
  {
    "name": "cloud-moon-rain",
    "icon": "fa-cloud-moon-rain fas"
  },
  {
    "name": "cloud-rain",
    "icon": "fa-cloud-rain fas"
  },
  {
    "name": "cloud-showers-heavy",
    "icon": "fa-cloud-showers-heavy fas"
  },
  {
    "name": "cloud-sun",
    "icon": "fa-cloud-sun fas"
  },
  {
    "name": "cloud-sun-rain",
    "icon": "fa-cloud-sun-rain fas"
  },
  {
    "name": "cloud-upload-alt",
    "icon": "fa-cloud-upload-alt fas"
  },
  {
    "name": "cloudflare",
    "icon": "fa-cloudflare fab"
  },
  {
    "name": "cloudscale",
    "icon": "fa-cloudscale fab"
  },
  {
    "name": "cloudsmith",
    "icon": "fa-cloudsmith fab"
  },
  {
    "name": "cloudversify",
    "icon": "fa-cloudversify fab"
  },
  {
    "name": "cocktail",
    "icon": "fa-cocktail fas"
  },
  {
    "name": "code",
    "icon": "fa-code fas"
  },
  {
    "name": "code-branch",
    "icon": "fa-code-branch fas"
  },
  {
    "name": "codepen",
    "icon": "fa-codepen fab"
  },
  {
    "name": "codiepie",
    "icon": "fa-codiepie fab"
  },
  {
    "name": "coffee",
    "icon": "fa-coffee fas"
  },
  {
    "name": "cog",
    "icon": "fa-cog fas"
  },
  {
    "name": "cogs",
    "icon": "fa-cogs fas"
  },
  {
    "name": "coins",
    "icon": "fa-coins fas"
  },
  {
    "name": "columns",
    "icon": "fa-columns fas"
  },
  {
    "name": "comment",
    "icon": "fa-comment fas"
  },
  {
    "name": "comment-alt",
    "icon": "fa-comment-alt fas"
  },
  {
    "name": "comment-dollar",
    "icon": "fa-comment-dollar fas"
  },
  {
    "name": "comment-dots",
    "icon": "fa-comment-dots fas"
  },
  {
    "name": "comment-medical",
    "icon": "fa-comment-medical fas"
  },
  {
    "name": "comment-slash",
    "icon": "fa-comment-slash fas"
  },
  {
    "name": "comments",
    "icon": "fa-comments fas"
  },
  {
    "name": "comments-dollar",
    "icon": "fa-comments-dollar fas"
  },
  {
    "name": "compact-disc",
    "icon": "fa-compact-disc fas"
  },
  {
    "name": "compass",
    "icon": "fa-compass fas"
  },
  {
    "name": "compress",
    "icon": "fa-compress fas"
  },
  {
    "name": "compress-alt",
    "icon": "fa-compress-alt fas"
  },
  {
    "name": "compress-arrows-alt",
    "icon": "fa-compress-arrows-alt fas"
  },
  {
    "name": "concierge-bell",
    "icon": "fa-concierge-bell fas"
  },
  {
    "name": "confluence",
    "icon": "fa-confluence fab"
  },
  {
    "name": "connectdevelop",
    "icon": "fa-connectdevelop fab"
  },
  {
    "name": "contao",
    "icon": "fa-contao fab"
  },
  {
    "name": "cookie",
    "icon": "fa-cookie fas"
  },
  {
    "name": "cookie-bite",
    "icon": "fa-cookie-bite fas"
  },
  {
    "name": "copy",
    "icon": "fa-copy fas"
  },
  {
    "name": "copyright",
    "icon": "fa-copyright fas"
  },
  {
    "name": "cotton-bureau",
    "icon": "fa-cotton-bureau fab"
  },
  {
    "name": "couch",
    "icon": "fa-couch fas"
  },
  {
    "name": "cpanel",
    "icon": "fa-cpanel fab"
  },
  {
    "name": "creative-commons",
    "icon": "fa-creative-commons fab"
  },
  {
    "name": "creative-commons-by",
    "icon": "fa-creative-commons-by fab"
  },
  {
    "name": "creative-commons-nc",
    "icon": "fa-creative-commons-nc fab"
  },
  {
    "name": "creative-commons-nc-eu",
    "icon": "fa-creative-commons-nc-eu fab"
  },
  {
    "name": "creative-commons-nc-jp",
    "icon": "fa-creative-commons-nc-jp fab"
  },
  {
    "name": "creative-commons-nd",
    "icon": "fa-creative-commons-nd fab"
  },
  {
    "name": "creative-commons-pd",
    "icon": "fa-creative-commons-pd fab"
  },
  {
    "name": "creative-commons-pd-alt",
    "icon": "fa-creative-commons-pd-alt fab"
  },
  {
    "name": "creative-commons-remix",
    "icon": "fa-creative-commons-remix fab"
  },
  {
    "name": "creative-commons-sa",
    "icon": "fa-creative-commons-sa fab"
  },
  {
    "name": "creative-commons-sampling",
    "icon": "fa-creative-commons-sampling fab"
  },
  {
    "name": "creative-commons-sampling-plus",
    "icon": "fa-creative-commons-sampling-plus fab"
  },
  {
    "name": "creative-commons-share",
    "icon": "fa-creative-commons-share fab"
  },
  {
    "name": "creative-commons-zero",
    "icon": "fa-creative-commons-zero fab"
  },
  {
    "name": "credit-card",
    "icon": "fa-credit-card fas"
  },
  {
    "name": "critical-role",
    "icon": "fa-critical-role fab"
  },
  {
    "name": "crop",
    "icon": "fa-crop fas"
  },
  {
    "name": "crop-alt",
    "icon": "fa-crop-alt fas"
  },
  {
    "name": "cross",
    "icon": "fa-cross fas"
  },
  {
    "name": "crosshairs",
    "icon": "fa-crosshairs fas"
  },
  {
    "name": "crow",
    "icon": "fa-crow fas"
  },
  {
    "name": "crown",
    "icon": "fa-crown fas"
  },
  {
    "name": "crutch",
    "icon": "fa-crutch fas"
  },
  {
    "name": "css3",
    "icon": "fa-css3 fab"
  },
  {
    "name": "css3-alt",
    "icon": "fa-css3-alt fab"
  },
  {
    "name": "cube",
    "icon": "fa-cube fas"
  },
  {
    "name": "cubes",
    "icon": "fa-cubes fas"
  },
  {
    "name": "cut",
    "icon": "fa-cut fas"
  },
  {
    "name": "cuttlefish",
    "icon": "fa-cuttlefish fab"
  },
  {
    "name": "d-and-d",
    "icon": "fa-d-and-d fab"
  },
  {
    "name": "d-and-d-beyond",
    "icon": "fa-d-and-d-beyond fab"
  },
  {
    "name": "dailymotion",
    "icon": "fa-dailymotion fab"
  },
  {
    "name": "dashcube",
    "icon": "fa-dashcube fab"
  },
  {
    "name": "database",
    "icon": "fa-database fas"
  },
  {
    "name": "deaf",
    "icon": "fa-deaf fas"
  },
  {
    "name": "deezer",
    "icon": "fa-deezer fab"
  },
  {
    "name": "delicious",
    "icon": "fa-delicious fab"
  },
  {
    "name": "democrat",
    "icon": "fa-democrat fas"
  },
  {
    "name": "deploydog",
    "icon": "fa-deploydog fab"
  },
  {
    "name": "deskpro",
    "icon": "fa-deskpro fab"
  },
  {
    "name": "desktop",
    "icon": "fa-desktop fas"
  },
  {
    "name": "dev",
    "icon": "fa-dev fab"
  },
  {
    "name": "deviantart",
    "icon": "fa-deviantart fab"
  },
  {
    "name": "dharmachakra",
    "icon": "fa-dharmachakra fas"
  },
  {
    "name": "dhl",
    "icon": "fa-dhl fab"
  },
  {
    "name": "diagnoses",
    "icon": "fa-diagnoses fas"
  },
  {
    "name": "diaspora",
    "icon": "fa-diaspora fab"
  },
  {
    "name": "dice",
    "icon": "fa-dice fas"
  },
  {
    "name": "dice-d20",
    "icon": "fa-dice-d20 fas"
  },
  {
    "name": "dice-d6",
    "icon": "fa-dice-d6 fas"
  },
  {
    "name": "dice-five",
    "icon": "fa-dice-five fas"
  },
  {
    "name": "dice-four",
    "icon": "fa-dice-four fas"
  },
  {
    "name": "dice-one",
    "icon": "fa-dice-one fas"
  },
  {
    "name": "dice-six",
    "icon": "fa-dice-six fas"
  },
  {
    "name": "dice-three",
    "icon": "fa-dice-three fas"
  },
  {
    "name": "dice-two",
    "icon": "fa-dice-two fas"
  },
  {
    "name": "digg",
    "icon": "fa-digg fab"
  },
  {
    "name": "digital-ocean",
    "icon": "fa-digital-ocean fab"
  },
  {
    "name": "digital-tachograph",
    "icon": "fa-digital-tachograph fas"
  },
  {
    "name": "directions",
    "icon": "fa-directions fas"
  },
  {
    "name": "discord",
    "icon": "fa-discord fab"
  },
  {
    "name": "discourse",
    "icon": "fa-discourse fab"
  },
  {
    "name": "disease",
    "icon": "fa-disease fas"
  },
  {
    "name": "divide",
    "icon": "fa-divide fas"
  },
  {
    "name": "dizzy",
    "icon": "fa-dizzy fas"
  },
  {
    "name": "dna",
    "icon": "fa-dna fas"
  },
  {
    "name": "dochub",
    "icon": "fa-dochub fab"
  },
  {
    "name": "docker",
    "icon": "fa-docker fab"
  },
  {
    "name": "dog",
    "icon": "fa-dog fas"
  },
  {
    "name": "dollar-sign",
    "icon": "fa-dollar-sign fas"
  },
  {
    "name": "dolly",
    "icon": "fa-dolly fas"
  },
  {
    "name": "dolly-flatbed",
    "icon": "fa-dolly-flatbed fas"
  },
  {
    "name": "donate",
    "icon": "fa-donate fas"
  },
  {
    "name": "door-closed",
    "icon": "fa-door-closed fas"
  },
  {
    "name": "door-open",
    "icon": "fa-door-open fas"
  },
  {
    "name": "dot-circle",
    "icon": "fa-dot-circle fas"
  },
  {
    "name": "dove",
    "icon": "fa-dove fas"
  },
  {
    "name": "download",
    "icon": "fa-download fas"
  },
  {
    "name": "draft2digital",
    "icon": "fa-draft2digital fab"
  },
  {
    "name": "drafting-compass",
    "icon": "fa-drafting-compass fas"
  },
  {
    "name": "dragon",
    "icon": "fa-dragon fas"
  },
  {
    "name": "draw-polygon",
    "icon": "fa-draw-polygon fas"
  },
  {
    "name": "dribbble",
    "icon": "fa-dribbble fab"
  },
  {
    "name": "dribbble-square",
    "icon": "fa-dribbble-square fab"
  },
  {
    "name": "dropbox",
    "icon": "fa-dropbox fab"
  },
  {
    "name": "drum",
    "icon": "fa-drum fas"
  },
  {
    "name": "drum-steelpan",
    "icon": "fa-drum-steelpan fas"
  },
  {
    "name": "drumstick-bite",
    "icon": "fa-drumstick-bite fas"
  },
  {
    "name": "drupal",
    "icon": "fa-drupal fab"
  },
  {
    "name": "dumbbell",
    "icon": "fa-dumbbell fas"
  },
  {
    "name": "dumpster",
    "icon": "fa-dumpster fas"
  },
  {
    "name": "dumpster-fire",
    "icon": "fa-dumpster-fire fas"
  },
  {
    "name": "dungeon",
    "icon": "fa-dungeon fas"
  },
  {
    "name": "dyalog",
    "icon": "fa-dyalog fab"
  },
  {
    "name": "earlybirds",
    "icon": "fa-earlybirds fab"
  },
  {
    "name": "ebay",
    "icon": "fa-ebay fab"
  },
  {
    "name": "edge",
    "icon": "fa-edge fab"
  },
  {
    "name": "edge-legacy",
    "icon": "fa-edge-legacy fab"
  },
  {
    "name": "edit",
    "icon": "fa-edit fas"
  },
  {
    "name": "egg",
    "icon": "fa-egg fas"
  },
  {
    "name": "eject",
    "icon": "fa-eject fas"
  },
  {
    "name": "elementor",
    "icon": "fa-elementor fab"
  },
  {
    "name": "ellipsis-h",
    "icon": "fa-ellipsis-h fas"
  },
  {
    "name": "ellipsis-v",
    "icon": "fa-ellipsis-v fas"
  },
  {
    "name": "ello",
    "icon": "fa-ello fab"
  },
  {
    "name": "ember",
    "icon": "fa-ember fab"
  },
  {
    "name": "empire",
    "icon": "fa-empire fab"
  },
  {
    "name": "envelope",
    "icon": "fa-envelope fas"
  },
  {
    "name": "envelope-open",
    "icon": "fa-envelope-open fas"
  },
  {
    "name": "envelope-open-text",
    "icon": "fa-envelope-open-text fas"
  },
  {
    "name": "envelope-square",
    "icon": "fa-envelope-square fas"
  },
  {
    "name": "envira",
    "icon": "fa-envira fab"
  },
  {
    "name": "equals",
    "icon": "fa-equals fas"
  },
  {
    "name": "eraser",
    "icon": "fa-eraser fas"
  },
  {
    "name": "erlang",
    "icon": "fa-erlang fab"
  },
  {
    "name": "ethereum",
    "icon": "fa-ethereum fab"
  },
  {
    "name": "ethernet",
    "icon": "fa-ethernet fas"
  },
  {
    "name": "etsy",
    "icon": "fa-etsy fab"
  },
  {
    "name": "euro-sign",
    "icon": "fa-euro-sign fas"
  },
  {
    "name": "evernote",
    "icon": "fa-evernote fab"
  },
  {
    "name": "exchange-alt",
    "icon": "fa-exchange-alt fas"
  },
  {
    "name": "exclamation",
    "icon": "fa-exclamation fas"
  },
  {
    "name": "exclamation-circle",
    "icon": "fa-exclamation-circle fas"
  },
  {
    "name": "exclamation-triangle",
    "icon": "fa-exclamation-triangle fas"
  },
  {
    "name": "expand",
    "icon": "fa-expand fas"
  },
  {
    "name": "expand-alt",
    "icon": "fa-expand-alt fas"
  },
  {
    "name": "expand-arrows-alt",
    "icon": "fa-expand-arrows-alt fas"
  },
  {
    "name": "expeditedssl",
    "icon": "fa-expeditedssl fab"
  },
  {
    "name": "external-link-alt",
    "icon": "fa-external-link-alt fas"
  },
  {
    "name": "external-link-square-alt",
    "icon": "fa-external-link-square-alt fas"
  },
  {
    "name": "eye",
    "icon": "fa-eye fas"
  },
  {
    "name": "eye-dropper",
    "icon": "fa-eye-dropper fas"
  },
  {
    "name": "eye-slash",
    "icon": "fa-eye-slash fas"
  },
  {
    "name": "facebook",
    "icon": "fa-facebook fab"
  },
  {
    "name": "facebook-f",
    "icon": "fa-facebook-f fab"
  },
  {
    "name": "facebook-messenger",
    "icon": "fa-facebook-messenger fab"
  },
  {
    "name": "facebook-square",
    "icon": "fa-facebook-square fab"
  },
  {
    "name": "fan",
    "icon": "fa-fan fas"
  },
  {
    "name": "fantasy-flight-games",
    "icon": "fa-fantasy-flight-games fab"
  },
  {
    "name": "fast-backward",
    "icon": "fa-fast-backward fas"
  },
  {
    "name": "fast-forward",
    "icon": "fa-fast-forward fas"
  },
  {
    "name": "faucet",
    "icon": "fa-faucet fas"
  },
  {
    "name": "fax",
    "icon": "fa-fax fas"
  },
  {
    "name": "feather",
    "icon": "fa-feather fas"
  },
  {
    "name": "feather-alt",
    "icon": "fa-feather-alt fas"
  },
  {
    "name": "fedex",
    "icon": "fa-fedex fab"
  },
  {
    "name": "fedora",
    "icon": "fa-fedora fab"
  },
  {
    "name": "female",
    "icon": "fa-female fas"
  },
  {
    "name": "fighter-jet",
    "icon": "fa-fighter-jet fas"
  },
  {
    "name": "figma",
    "icon": "fa-figma fab"
  },
  {
    "name": "file",
    "icon": "fa-file fas"
  },
  {
    "name": "file-alt",
    "icon": "fa-file-alt fas"
  },
  {
    "name": "file-archive",
    "icon": "fa-file-archive fas"
  },
  {
    "name": "file-audio",
    "icon": "fa-file-audio fas"
  },
  {
    "name": "file-code",
    "icon": "fa-file-code fas"
  },
  {
    "name": "file-contract",
    "icon": "fa-file-contract fas"
  },
  {
    "name": "file-csv",
    "icon": "fa-file-csv fas"
  },
  {
    "name": "file-download",
    "icon": "fa-file-download fas"
  },
  {
    "name": "file-excel",
    "icon": "fa-file-excel fas"
  },
  {
    "name": "file-export",
    "icon": "fa-file-export fas"
  },
  {
    "name": "file-image",
    "icon": "fa-file-image fas"
  },
  {
    "name": "file-import",
    "icon": "fa-file-import fas"
  },
  {
    "name": "file-invoice",
    "icon": "fa-file-invoice fas"
  },
  {
    "name": "file-invoice-dollar",
    "icon": "fa-file-invoice-dollar fas"
  },
  {
    "name": "file-medical",
    "icon": "fa-file-medical fas"
  },
  {
    "name": "file-medical-alt",
    "icon": "fa-file-medical-alt fas"
  },
  {
    "name": "file-pdf",
    "icon": "fa-file-pdf fas"
  },
  {
    "name": "file-powerpoint",
    "icon": "fa-file-powerpoint fas"
  },
  {
    "name": "file-prescription",
    "icon": "fa-file-prescription fas"
  },
  {
    "name": "file-signature",
    "icon": "fa-file-signature fas"
  },
  {
    "name": "file-upload",
    "icon": "fa-file-upload fas"
  },
  {
    "name": "file-video",
    "icon": "fa-file-video fas"
  },
  {
    "name": "file-word",
    "icon": "fa-file-word fas"
  },
  {
    "name": "fill",
    "icon": "fa-fill fas"
  },
  {
    "name": "fill-drip",
    "icon": "fa-fill-drip fas"
  },
  {
    "name": "film",
    "icon": "fa-film fas"
  },
  {
    "name": "filter",
    "icon": "fa-filter fas"
  },
  {
    "name": "fingerprint",
    "icon": "fa-fingerprint fas"
  },
  {
    "name": "fire",
    "icon": "fa-fire fas"
  },
  {
    "name": "fire-alt",
    "icon": "fa-fire-alt fas"
  },
  {
    "name": "fire-extinguisher",
    "icon": "fa-fire-extinguisher fas"
  },
  {
    "name": "firefox",
    "icon": "fa-firefox fab"
  },
  {
    "name": "firefox-browser",
    "icon": "fa-firefox-browser fab"
  },
  {
    "name": "first-aid",
    "icon": "fa-first-aid fas"
  },
  {
    "name": "first-order",
    "icon": "fa-first-order fab"
  },
  {
    "name": "first-order-alt",
    "icon": "fa-first-order-alt fab"
  },
  {
    "name": "firstdraft",
    "icon": "fa-firstdraft fab"
  },
  {
    "name": "fish",
    "icon": "fa-fish fas"
  },
  {
    "name": "fist-raised",
    "icon": "fa-fist-raised fas"
  },
  {
    "name": "flag",
    "icon": "fa-flag fas"
  },
  {
    "name": "flag-checkered",
    "icon": "fa-flag-checkered fas"
  },
  {
    "name": "flag-usa",
    "icon": "fa-flag-usa fas"
  },
  {
    "name": "flask",
    "icon": "fa-flask fas"
  },
  {
    "name": "flickr",
    "icon": "fa-flickr fab"
  },
  {
    "name": "flipboard",
    "icon": "fa-flipboard fab"
  },
  {
    "name": "flushed",
    "icon": "fa-flushed fas"
  },
  {
    "name": "fly",
    "icon": "fa-fly fab"
  },
  {
    "name": "folder",
    "icon": "fa-folder fas"
  },
  {
    "name": "folder-minus",
    "icon": "fa-folder-minus fas"
  },
  {
    "name": "folder-open",
    "icon": "fa-folder-open fas"
  },
  {
    "name": "folder-plus",
    "icon": "fa-folder-plus fas"
  },
  {
    "name": "font",
    "icon": "fa-font fas"
  },
  {
    "name": "font-awesome",
    "icon": "fa-font-awesome fab"
  },
  {
    "name": "font-awesome-alt",
    "icon": "fa-font-awesome-alt fab"
  },
  {
    "name": "font-awesome-flag",
    "icon": "fa-font-awesome-flag fab"
  },
  {
    "name": "fonticons",
    "icon": "fa-fonticons fab"
  },
  {
    "name": "fonticons-fi",
    "icon": "fa-fonticons-fi fab"
  },
  {
    "name": "football-ball",
    "icon": "fa-football-ball fas"
  },
  {
    "name": "fort-awesome",
    "icon": "fa-fort-awesome fab"
  },
  {
    "name": "fort-awesome-alt",
    "icon": "fa-fort-awesome-alt fab"
  },
  {
    "name": "forumbee",
    "icon": "fa-forumbee fab"
  },
  {
    "name": "forward",
    "icon": "fa-forward fas"
  },
  {
    "name": "foursquare",
    "icon": "fa-foursquare fab"
  },
  {
    "name": "free-code-camp",
    "icon": "fa-free-code-camp fab"
  },
  {
    "name": "freebsd",
    "icon": "fa-freebsd fab"
  },
  {
    "name": "frog",
    "icon": "fa-frog fas"
  },
  {
    "name": "frown",
    "icon": "fa-frown fas"
  },
  {
    "name": "frown-open",
    "icon": "fa-frown-open fas"
  },
  {
    "name": "fulcrum",
    "icon": "fa-fulcrum fab"
  },
  {
    "name": "funnel-dollar",
    "icon": "fa-funnel-dollar fas"
  },
  {
    "name": "futbol",
    "icon": "fa-futbol fas"
  },
  {
    "name": "galactic-republic",
    "icon": "fa-galactic-republic fab"
  },
  {
    "name": "galactic-senate",
    "icon": "fa-galactic-senate fab"
  },
  {
    "name": "gamepad",
    "icon": "fa-gamepad fas"
  },
  {
    "name": "gas-pump",
    "icon": "fa-gas-pump fas"
  },
  {
    "name": "gavel",
    "icon": "fa-gavel fas"
  },
  {
    "name": "gem",
    "icon": "fa-gem fas"
  },
  {
    "name": "genderless",
    "icon": "fa-genderless fas"
  },
  {
    "name": "get-pocket",
    "icon": "fa-get-pocket fab"
  },
  {
    "name": "gg",
    "icon": "fa-gg fab"
  },
  {
    "name": "gg-circle",
    "icon": "fa-gg-circle fab"
  },
  {
    "name": "ghost",
    "icon": "fa-ghost fas"
  },
  {
    "name": "gift",
    "icon": "fa-gift fas"
  },
  {
    "name": "gifts",
    "icon": "fa-gifts fas"
  },
  {
    "name": "git",
    "icon": "fa-git fab"
  },
  {
    "name": "git-alt",
    "icon": "fa-git-alt fab"
  },
  {
    "name": "git-square",
    "icon": "fa-git-square fab"
  },
  {
    "name": "github",
    "icon": "fa-github fab"
  },
  {
    "name": "github-alt",
    "icon": "fa-github-alt fab"
  },
  {
    "name": "github-square",
    "icon": "fa-github-square fab"
  },
  {
    "name": "gitkraken",
    "icon": "fa-gitkraken fab"
  },
  {
    "name": "gitlab",
    "icon": "fa-gitlab fab"
  },
  {
    "name": "gitter",
    "icon": "fa-gitter fab"
  },
  {
    "name": "glass-cheers",
    "icon": "fa-glass-cheers fas"
  },
  {
    "name": "glass-martini",
    "icon": "fa-glass-martini fas"
  },
  {
    "name": "glass-martini-alt",
    "icon": "fa-glass-martini-alt fas"
  },
  {
    "name": "glass-whiskey",
    "icon": "fa-glass-whiskey fas"
  },
  {
    "name": "glasses",
    "icon": "fa-glasses fas"
  },
  {
    "name": "glide",
    "icon": "fa-glide fab"
  },
  {
    "name": "glide-g",
    "icon": "fa-glide-g fab"
  },
  {
    "name": "globe",
    "icon": "fa-globe fas"
  },
  {
    "name": "globe-africa",
    "icon": "fa-globe-africa fas"
  },
  {
    "name": "globe-americas",
    "icon": "fa-globe-americas fas"
  },
  {
    "name": "globe-asia",
    "icon": "fa-globe-asia fas"
  },
  {
    "name": "globe-europe",
    "icon": "fa-globe-europe fas"
  },
  {
    "name": "gofore",
    "icon": "fa-gofore fab"
  },
  {
    "name": "golf-ball",
    "icon": "fa-golf-ball fas"
  },
  {
    "name": "goodreads",
    "icon": "fa-goodreads fab"
  },
  {
    "name": "goodreads-g",
    "icon": "fa-goodreads-g fab"
  },
  {
    "name": "google",
    "icon": "fa-google fab"
  },
  {
    "name": "google-drive",
    "icon": "fa-google-drive fab"
  },
  {
    "name": "google-pay",
    "icon": "fa-google-pay fab"
  },
  {
    "name": "google-play",
    "icon": "fa-google-play fab"
  },
  {
    "name": "google-plus",
    "icon": "fa-google-plus fab"
  },
  {
    "name": "google-plus-g",
    "icon": "fa-google-plus-g fab"
  },
  {
    "name": "google-plus-square",
    "icon": "fa-google-plus-square fab"
  },
  {
    "name": "google-wallet",
    "icon": "fa-google-wallet fab"
  },
  {
    "name": "gopuram",
    "icon": "fa-gopuram fas"
  },
  {
    "name": "graduation-cap",
    "icon": "fa-graduation-cap fas"
  },
  {
    "name": "gratipay",
    "icon": "fa-gratipay fab"
  },
  {
    "name": "grav",
    "icon": "fa-grav fab"
  },
  {
    "name": "greater-than",
    "icon": "fa-greater-than fas"
  },
  {
    "name": "greater-than-equal",
    "icon": "fa-greater-than-equal fas"
  },
  {
    "name": "grimace",
    "icon": "fa-grimace fas"
  },
  {
    "name": "grin",
    "icon": "fa-grin fas"
  },
  {
    "name": "grin-alt",
    "icon": "fa-grin-alt fas"
  },
  {
    "name": "grin-beam",
    "icon": "fa-grin-beam fas"
  },
  {
    "name": "grin-beam-sweat",
    "icon": "fa-grin-beam-sweat fas"
  },
  {
    "name": "grin-hearts",
    "icon": "fa-grin-hearts fas"
  },
  {
    "name": "grin-squint",
    "icon": "fa-grin-squint fas"
  },
  {
    "name": "grin-squint-tears",
    "icon": "fa-grin-squint-tears fas"
  },
  {
    "name": "grin-stars",
    "icon": "fa-grin-stars fas"
  },
  {
    "name": "grin-tears",
    "icon": "fa-grin-tears fas"
  },
  {
    "name": "grin-tongue",
    "icon": "fa-grin-tongue fas"
  },
  {
    "name": "grin-tongue-squint",
    "icon": "fa-grin-tongue-squint fas"
  },
  {
    "name": "grin-tongue-wink",
    "icon": "fa-grin-tongue-wink fas"
  },
  {
    "name": "grin-wink",
    "icon": "fa-grin-wink fas"
  },
  {
    "name": "grip-horizontal",
    "icon": "fa-grip-horizontal fas"
  },
  {
    "name": "grip-lines",
    "icon": "fa-grip-lines fas"
  },
  {
    "name": "grip-lines-vertical",
    "icon": "fa-grip-lines-vertical fas"
  },
  {
    "name": "grip-vertical",
    "icon": "fa-grip-vertical fas"
  },
  {
    "name": "gripfire",
    "icon": "fa-gripfire fab"
  },
  {
    "name": "grunt",
    "icon": "fa-grunt fab"
  },
  {
    "name": "guilded",
    "icon": "fa-guilded fab"
  },
  {
    "name": "guitar",
    "icon": "fa-guitar fas"
  },
  {
    "name": "gulp",
    "icon": "fa-gulp fab"
  },
  {
    "name": "h-square",
    "icon": "fa-h-square fas"
  },
  {
    "name": "hacker-news",
    "icon": "fa-hacker-news fab"
  },
  {
    "name": "hacker-news-square",
    "icon": "fa-hacker-news-square fab"
  },
  {
    "name": "hackerrank",
    "icon": "fa-hackerrank fab"
  },
  {
    "name": "hamburger",
    "icon": "fa-hamburger fas"
  },
  {
    "name": "hammer",
    "icon": "fa-hammer fas"
  },
  {
    "name": "hamsa",
    "icon": "fa-hamsa fas"
  },
  {
    "name": "hand-holding",
    "icon": "fa-hand-holding fas"
  },
  {
    "name": "hand-holding-heart",
    "icon": "fa-hand-holding-heart fas"
  },
  {
    "name": "hand-holding-medical",
    "icon": "fa-hand-holding-medical fas"
  },
  {
    "name": "hand-holding-usd",
    "icon": "fa-hand-holding-usd fas"
  },
  {
    "name": "hand-holding-water",
    "icon": "fa-hand-holding-water fas"
  },
  {
    "name": "hand-lizard",
    "icon": "fa-hand-lizard fas"
  },
  {
    "name": "hand-middle-finger",
    "icon": "fa-hand-middle-finger fas"
  },
  {
    "name": "hand-paper",
    "icon": "fa-hand-paper fas"
  },
  {
    "name": "hand-peace",
    "icon": "fa-hand-peace fas"
  },
  {
    "name": "hand-point-down",
    "icon": "fa-hand-point-down fas"
  },
  {
    "name": "hand-point-left",
    "icon": "fa-hand-point-left fas"
  },
  {
    "name": "hand-point-right",
    "icon": "fa-hand-point-right fas"
  },
  {
    "name": "hand-point-up",
    "icon": "fa-hand-point-up fas"
  },
  {
    "name": "hand-pointer",
    "icon": "fa-hand-pointer fas"
  },
  {
    "name": "hand-rock",
    "icon": "fa-hand-rock fas"
  },
  {
    "name": "hand-scissors",
    "icon": "fa-hand-scissors fas"
  },
  {
    "name": "hand-sparkles",
    "icon": "fa-hand-sparkles fas"
  },
  {
    "name": "hand-spock",
    "icon": "fa-hand-spock fas"
  },
  {
    "name": "hands",
    "icon": "fa-hands fas"
  },
  {
    "name": "hands-helping",
    "icon": "fa-hands-helping fas"
  },
  {
    "name": "hands-wash",
    "icon": "fa-hands-wash fas"
  },
  {
    "name": "handshake",
    "icon": "fa-handshake fas"
  },
  {
    "name": "handshake-alt-slash",
    "icon": "fa-handshake-alt-slash fas"
  },
  {
    "name": "handshake-slash",
    "icon": "fa-handshake-slash fas"
  },
  {
    "name": "hanukiah",
    "icon": "fa-hanukiah fas"
  },
  {
    "name": "hard-hat",
    "icon": "fa-hard-hat fas"
  },
  {
    "name": "hashtag",
    "icon": "fa-hashtag fas"
  },
  {
    "name": "hat-cowboy",
    "icon": "fa-hat-cowboy fas"
  },
  {
    "name": "hat-cowboy-side",
    "icon": "fa-hat-cowboy-side fas"
  },
  {
    "name": "hat-wizard",
    "icon": "fa-hat-wizard fas"
  },
  {
    "name": "hdd",
    "icon": "fa-hdd fas"
  },
  {
    "name": "head-side-cough",
    "icon": "fa-head-side-cough fas"
  },
  {
    "name": "head-side-cough-slash",
    "icon": "fa-head-side-cough-slash fas"
  },
  {
    "name": "head-side-mask",
    "icon": "fa-head-side-mask fas"
  },
  {
    "name": "head-side-virus",
    "icon": "fa-head-side-virus fas"
  },
  {
    "name": "heading",
    "icon": "fa-heading fas"
  },
  {
    "name": "headphones",
    "icon": "fa-headphones fas"
  },
  {
    "name": "headphones-alt",
    "icon": "fa-headphones-alt fas"
  },
  {
    "name": "headset",
    "icon": "fa-headset fas"
  },
  {
    "name": "heart",
    "icon": "fa-heart fas"
  },
  {
    "name": "heart-broken",
    "icon": "fa-heart-broken fas"
  },
  {
    "name": "heartbeat",
    "icon": "fa-heartbeat fas"
  },
  {
    "name": "helicopter",
    "icon": "fa-helicopter fas"
  },
  {
    "name": "highlighter",
    "icon": "fa-highlighter fas"
  },
  {
    "name": "hiking",
    "icon": "fa-hiking fas"
  },
  {
    "name": "hippo",
    "icon": "fa-hippo fas"
  },
  {
    "name": "hips",
    "icon": "fa-hips fab"
  },
  {
    "name": "hire-a-helper",
    "icon": "fa-hire-a-helper fab"
  },
  {
    "name": "history",
    "icon": "fa-history fas"
  },
  {
    "name": "hive",
    "icon": "fa-hive fab"
  },
  {
    "name": "hockey-puck",
    "icon": "fa-hockey-puck fas"
  },
  {
    "name": "holly-berry",
    "icon": "fa-holly-berry fas"
  },
  {
    "name": "home",
    "icon": "fa-home fas"
  },
  {
    "name": "hooli",
    "icon": "fa-hooli fab"
  },
  {
    "name": "hornbill",
    "icon": "fa-hornbill fab"
  },
  {
    "name": "horse",
    "icon": "fa-horse fas"
  },
  {
    "name": "horse-head",
    "icon": "fa-horse-head fas"
  },
  {
    "name": "hospital",
    "icon": "fa-hospital fas"
  },
  {
    "name": "hospital-alt",
    "icon": "fa-hospital-alt fas"
  },
  {
    "name": "hospital-symbol",
    "icon": "fa-hospital-symbol fas"
  },
  {
    "name": "hospital-user",
    "icon": "fa-hospital-user fas"
  },
  {
    "name": "hot-tub",
    "icon": "fa-hot-tub fas"
  },
  {
    "name": "hotdog",
    "icon": "fa-hotdog fas"
  },
  {
    "name": "hotel",
    "icon": "fa-hotel fas"
  },
  {
    "name": "hotjar",
    "icon": "fa-hotjar fab"
  },
  {
    "name": "hourglass",
    "icon": "fa-hourglass fas"
  },
  {
    "name": "hourglass-end",
    "icon": "fa-hourglass-end fas"
  },
  {
    "name": "hourglass-half",
    "icon": "fa-hourglass-half fas"
  },
  {
    "name": "hourglass-start",
    "icon": "fa-hourglass-start fas"
  },
  {
    "name": "house-damage",
    "icon": "fa-house-damage fas"
  },
  {
    "name": "house-user",
    "icon": "fa-house-user fas"
  },
  {
    "name": "houzz",
    "icon": "fa-houzz fab"
  },
  {
    "name": "hryvnia",
    "icon": "fa-hryvnia fas"
  },
  {
    "name": "html5",
    "icon": "fa-html5 fab"
  },
  {
    "name": "hubspot",
    "icon": "fa-hubspot fab"
  },
  {
    "name": "i-cursor",
    "icon": "fa-i-cursor fas"
  },
  {
    "name": "ice-cream",
    "icon": "fa-ice-cream fas"
  },
  {
    "name": "icicles",
    "icon": "fa-icicles fas"
  },
  {
    "name": "icons",
    "icon": "fa-icons fas"
  },
  {
    "name": "id-badge",
    "icon": "fa-id-badge fas"
  },
  {
    "name": "id-card",
    "icon": "fa-id-card fas"
  },
  {
    "name": "id-card-alt",
    "icon": "fa-id-card-alt fas"
  },
  {
    "name": "ideal",
    "icon": "fa-ideal fab"
  },
  {
    "name": "igloo",
    "icon": "fa-igloo fas"
  },
  {
    "name": "image",
    "icon": "fa-image fas"
  },
  {
    "name": "images",
    "icon": "fa-images fas"
  },
  {
    "name": "imdb",
    "icon": "fa-imdb fab"
  },
  {
    "name": "inbox",
    "icon": "fa-inbox fas"
  },
  {
    "name": "indent",
    "icon": "fa-indent fas"
  },
  {
    "name": "industry",
    "icon": "fa-industry fas"
  },
  {
    "name": "infinity",
    "icon": "fa-infinity fas"
  },
  {
    "name": "info",
    "icon": "fa-info fas"
  },
  {
    "name": "info-circle",
    "icon": "fa-info-circle fas"
  },
  {
    "name": "innosoft",
    "icon": "fa-innosoft fab"
  },
  {
    "name": "instagram",
    "icon": "fa-instagram fab"
  },
  {
    "name": "instagram-square",
    "icon": "fa-instagram-square fab"
  },
  {
    "name": "instalod",
    "icon": "fa-instalod fab"
  },
  {
    "name": "intercom",
    "icon": "fa-intercom fab"
  },
  {
    "name": "internet-explorer",
    "icon": "fa-internet-explorer fab"
  },
  {
    "name": "invision",
    "icon": "fa-invision fab"
  },
  {
    "name": "ioxhost",
    "icon": "fa-ioxhost fab"
  },
  {
    "name": "italic",
    "icon": "fa-italic fas"
  },
  {
    "name": "itch-io",
    "icon": "fa-itch-io fab"
  },
  {
    "name": "itunes",
    "icon": "fa-itunes fab"
  },
  {
    "name": "itunes-note",
    "icon": "fa-itunes-note fab"
  },
  {
    "name": "java",
    "icon": "fa-java fab"
  },
  {
    "name": "jedi",
    "icon": "fa-jedi fas"
  },
  {
    "name": "jedi-order",
    "icon": "fa-jedi-order fab"
  },
  {
    "name": "jenkins",
    "icon": "fa-jenkins fab"
  },
  {
    "name": "jira",
    "icon": "fa-jira fab"
  },
  {
    "name": "joget",
    "icon": "fa-joget fab"
  },
  {
    "name": "joint",
    "icon": "fa-joint fas"
  },
  {
    "name": "joomla",
    "icon": "fa-joomla fab"
  },
  {
    "name": "journal-whills",
    "icon": "fa-journal-whills fas"
  },
  {
    "name": "js",
    "icon": "fa-js fab"
  },
  {
    "name": "js-square",
    "icon": "fa-js-square fab"
  },
  {
    "name": "jsfiddle",
    "icon": "fa-jsfiddle fab"
  },
  {
    "name": "kaaba",
    "icon": "fa-kaaba fas"
  },
  {
    "name": "kaggle",
    "icon": "fa-kaggle fab"
  },
  {
    "name": "key",
    "icon": "fa-key fas"
  },
  {
    "name": "keybase",
    "icon": "fa-keybase fab"
  },
  {
    "name": "keyboard",
    "icon": "fa-keyboard fas"
  },
  {
    "name": "keycdn",
    "icon": "fa-keycdn fab"
  },
  {
    "name": "khanda",
    "icon": "fa-khanda fas"
  },
  {
    "name": "kickstarter",
    "icon": "fa-kickstarter fab"
  },
  {
    "name": "kickstarter-k",
    "icon": "fa-kickstarter-k fab"
  },
  {
    "name": "kiss",
    "icon": "fa-kiss fas"
  },
  {
    "name": "kiss-beam",
    "icon": "fa-kiss-beam fas"
  },
  {
    "name": "kiss-wink-heart",
    "icon": "fa-kiss-wink-heart fas"
  },
  {
    "name": "kiwi-bird",
    "icon": "fa-kiwi-bird fas"
  },
  {
    "name": "korvue",
    "icon": "fa-korvue fab"
  },
  {
    "name": "landmark",
    "icon": "fa-landmark fas"
  },
  {
    "name": "language",
    "icon": "fa-language fas"
  },
  {
    "name": "laptop",
    "icon": "fa-laptop fas"
  },
  {
    "name": "laptop-code",
    "icon": "fa-laptop-code fas"
  },
  {
    "name": "laptop-house",
    "icon": "fa-laptop-house fas"
  },
  {
    "name": "laptop-medical",
    "icon": "fa-laptop-medical fas"
  },
  {
    "name": "laravel",
    "icon": "fa-laravel fab"
  },
  {
    "name": "lastfm",
    "icon": "fa-lastfm fab"
  },
  {
    "name": "lastfm-square",
    "icon": "fa-lastfm-square fab"
  },
  {
    "name": "laugh",
    "icon": "fa-laugh fas"
  },
  {
    "name": "laugh-beam",
    "icon": "fa-laugh-beam fas"
  },
  {
    "name": "laugh-squint",
    "icon": "fa-laugh-squint fas"
  },
  {
    "name": "laugh-wink",
    "icon": "fa-laugh-wink fas"
  },
  {
    "name": "layer-group",
    "icon": "fa-layer-group fas"
  },
  {
    "name": "leaf",
    "icon": "fa-leaf fas"
  },
  {
    "name": "leanpub",
    "icon": "fa-leanpub fab"
  },
  {
    "name": "lemon",
    "icon": "fa-lemon fas"
  },
  {
    "name": "less",
    "icon": "fa-less fab"
  },
  {
    "name": "less-than",
    "icon": "fa-less-than fas"
  },
  {
    "name": "less-than-equal",
    "icon": "fa-less-than-equal fas"
  },
  {
    "name": "level-down-alt",
    "icon": "fa-level-down-alt fas"
  },
  {
    "name": "level-up-alt",
    "icon": "fa-level-up-alt fas"
  },
  {
    "name": "life-ring",
    "icon": "fa-life-ring fas"
  },
  {
    "name": "lightbulb",
    "icon": "fa-lightbulb fas"
  },
  {
    "name": "line",
    "icon": "fa-line fab"
  },
  {
    "name": "link",
    "icon": "fa-link fas"
  },
  {
    "name": "linkedin",
    "icon": "fa-linkedin fab"
  },
  {
    "name": "linkedin-in",
    "icon": "fa-linkedin-in fab"
  },
  {
    "name": "linode",
    "icon": "fa-linode fab"
  },
  {
    "name": "linux",
    "icon": "fa-linux fab"
  },
  {
    "name": "lira-sign",
    "icon": "fa-lira-sign fas"
  },
  {
    "name": "list",
    "icon": "fa-list fas"
  },
  {
    "name": "list-alt",
    "icon": "fa-list-alt fas"
  },
  {
    "name": "list-ol",
    "icon": "fa-list-ol fas"
  },
  {
    "name": "list-ul",
    "icon": "fa-list-ul fas"
  },
  {
    "name": "location-arrow",
    "icon": "fa-location-arrow fas"
  },
  {
    "name": "lock",
    "icon": "fa-lock fas"
  },
  {
    "name": "lock-open",
    "icon": "fa-lock-open fas"
  },
  {
    "name": "long-arrow-alt-down",
    "icon": "fa-long-arrow-alt-down fas"
  },
  {
    "name": "long-arrow-alt-left",
    "icon": "fa-long-arrow-alt-left fas"
  },
  {
    "name": "long-arrow-alt-right",
    "icon": "fa-long-arrow-alt-right fas"
  },
  {
    "name": "long-arrow-alt-up",
    "icon": "fa-long-arrow-alt-up fas"
  },
  {
    "name": "low-vision",
    "icon": "fa-low-vision fas"
  },
  {
    "name": "luggage-cart",
    "icon": "fa-luggage-cart fas"
  },
  {
    "name": "lungs",
    "icon": "fa-lungs fas"
  },
  {
    "name": "lungs-virus",
    "icon": "fa-lungs-virus fas"
  },
  {
    "name": "lyft",
    "icon": "fa-lyft fab"
  },
  {
    "name": "magento",
    "icon": "fa-magento fab"
  },
  {
    "name": "magic",
    "icon": "fa-magic fas"
  },
  {
    "name": "magnet",
    "icon": "fa-magnet fas"
  },
  {
    "name": "mail-bulk",
    "icon": "fa-mail-bulk fas"
  },
  {
    "name": "mailchimp",
    "icon": "fa-mailchimp fab"
  },
  {
    "name": "male",
    "icon": "fa-male fas"
  },
  {
    "name": "mandalorian",
    "icon": "fa-mandalorian fab"
  },
  {
    "name": "map",
    "icon": "fa-map fas"
  },
  {
    "name": "map-marked",
    "icon": "fa-map-marked fas"
  },
  {
    "name": "map-marked-alt",
    "icon": "fa-map-marked-alt fas"
  },
  {
    "name": "map-marker",
    "icon": "fa-map-marker fas"
  },
  {
    "name": "map-marker-alt",
    "icon": "fa-map-marker-alt fas"
  },
  {
    "name": "map-pin",
    "icon": "fa-map-pin fas"
  },
  {
    "name": "map-signs",
    "icon": "fa-map-signs fas"
  },
  {
    "name": "markdown",
    "icon": "fa-markdown fab"
  },
  {
    "name": "marker",
    "icon": "fa-marker fas"
  },
  {
    "name": "mars",
    "icon": "fa-mars fas"
  },
  {
    "name": "mars-double",
    "icon": "fa-mars-double fas"
  },
  {
    "name": "mars-stroke",
    "icon": "fa-mars-stroke fas"
  },
  {
    "name": "mars-stroke-h",
    "icon": "fa-mars-stroke-h fas"
  },
  {
    "name": "mars-stroke-v",
    "icon": "fa-mars-stroke-v fas"
  },
  {
    "name": "mask",
    "icon": "fa-mask fas"
  },
  {
    "name": "mastodon",
    "icon": "fa-mastodon fab"
  },
  {
    "name": "maxcdn",
    "icon": "fa-maxcdn fab"
  },
  {
    "name": "mdb",
    "icon": "fa-mdb fab"
  },
  {
    "name": "medal",
    "icon": "fa-medal fas"
  },
  {
    "name": "medapps",
    "icon": "fa-medapps fab"
  },
  {
    "name": "medium",
    "icon": "fa-medium fab"
  },
  {
    "name": "medium-m",
    "icon": "fa-medium-m fab"
  },
  {
    "name": "medkit",
    "icon": "fa-medkit fas"
  },
  {
    "name": "medrt",
    "icon": "fa-medrt fab"
  },
  {
    "name": "meetup",
    "icon": "fa-meetup fab"
  },
  {
    "name": "megaport",
    "icon": "fa-megaport fab"
  },
  {
    "name": "meh",
    "icon": "fa-meh fas"
  },
  {
    "name": "meh-blank",
    "icon": "fa-meh-blank fas"
  },
  {
    "name": "meh-rolling-eyes",
    "icon": "fa-meh-rolling-eyes fas"
  },
  {
    "name": "memory",
    "icon": "fa-memory fas"
  },
  {
    "name": "mendeley",
    "icon": "fa-mendeley fab"
  },
  {
    "name": "menorah",
    "icon": "fa-menorah fas"
  },
  {
    "name": "mercury",
    "icon": "fa-mercury fas"
  },
  {
    "name": "meteor",
    "icon": "fa-meteor fas"
  },
  {
    "name": "microblog",
    "icon": "fa-microblog fab"
  },
  {
    "name": "microchip",
    "icon": "fa-microchip fas"
  },
  {
    "name": "microphone",
    "icon": "fa-microphone fas"
  },
  {
    "name": "microphone-alt",
    "icon": "fa-microphone-alt fas"
  },
  {
    "name": "microphone-alt-slash",
    "icon": "fa-microphone-alt-slash fas"
  },
  {
    "name": "microphone-slash",
    "icon": "fa-microphone-slash fas"
  },
  {
    "name": "microscope",
    "icon": "fa-microscope fas"
  },
  {
    "name": "microsoft",
    "icon": "fa-microsoft fab"
  },
  {
    "name": "minus",
    "icon": "fa-minus fas"
  },
  {
    "name": "minus-circle",
    "icon": "fa-minus-circle fas"
  },
  {
    "name": "minus-square",
    "icon": "fa-minus-square fas"
  },
  {
    "name": "mitten",
    "icon": "fa-mitten fas"
  },
  {
    "name": "mix",
    "icon": "fa-mix fab"
  },
  {
    "name": "mixcloud",
    "icon": "fa-mixcloud fab"
  },
  {
    "name": "mixer",
    "icon": "fa-mixer fab"
  },
  {
    "name": "mizuni",
    "icon": "fa-mizuni fab"
  },
  {
    "name": "mobile",
    "icon": "fa-mobile fas"
  },
  {
    "name": "mobile-alt",
    "icon": "fa-mobile-alt fas"
  },
  {
    "name": "modx",
    "icon": "fa-modx fab"
  },
  {
    "name": "monero",
    "icon": "fa-monero fab"
  },
  {
    "name": "money-bill",
    "icon": "fa-money-bill fas"
  },
  {
    "name": "money-bill-alt",
    "icon": "fa-money-bill-alt fas"
  },
  {
    "name": "money-bill-wave",
    "icon": "fa-money-bill-wave fas"
  },
  {
    "name": "money-bill-wave-alt",
    "icon": "fa-money-bill-wave-alt fas"
  },
  {
    "name": "money-check",
    "icon": "fa-money-check fas"
  },
  {
    "name": "money-check-alt",
    "icon": "fa-money-check-alt fas"
  },
  {
    "name": "monument",
    "icon": "fa-monument fas"
  },
  {
    "name": "moon",
    "icon": "fa-moon fas"
  },
  {
    "name": "mortar-pestle",
    "icon": "fa-mortar-pestle fas"
  },
  {
    "name": "mosque",
    "icon": "fa-mosque fas"
  },
  {
    "name": "motorcycle",
    "icon": "fa-motorcycle fas"
  },
  {
    "name": "mountain",
    "icon": "fa-mountain fas"
  },
  {
    "name": "mouse",
    "icon": "fa-mouse fas"
  },
  {
    "name": "mouse-pointer",
    "icon": "fa-mouse-pointer fas"
  },
  {
    "name": "mug-hot",
    "icon": "fa-mug-hot fas"
  },
  {
    "name": "music",
    "icon": "fa-music fas"
  },
  {
    "name": "napster",
    "icon": "fa-napster fab"
  },
  {
    "name": "neos",
    "icon": "fa-neos fab"
  },
  {
    "name": "network-wired",
    "icon": "fa-network-wired fas"
  },
  {
    "name": "neuter",
    "icon": "fa-neuter fas"
  },
  {
    "name": "newspaper",
    "icon": "fa-newspaper fas"
  },
  {
    "name": "nimblr",
    "icon": "fa-nimblr fab"
  },
  {
    "name": "node",
    "icon": "fa-node fab"
  },
  {
    "name": "node-js",
    "icon": "fa-node-js fab"
  },
  {
    "name": "not-equal",
    "icon": "fa-not-equal fas"
  },
  {
    "name": "notes-medical",
    "icon": "fa-notes-medical fas"
  },
  {
    "name": "npm",
    "icon": "fa-npm fab"
  },
  {
    "name": "ns8",
    "icon": "fa-ns8 fab"
  },
  {
    "name": "nutritionix",
    "icon": "fa-nutritionix fab"
  },
  {
    "name": "object-group",
    "icon": "fa-object-group fas"
  },
  {
    "name": "object-ungroup",
    "icon": "fa-object-ungroup fas"
  },
  {
    "name": "octopus-deploy",
    "icon": "fa-octopus-deploy fab"
  },
  {
    "name": "odnoklassniki",
    "icon": "fa-odnoklassniki fab"
  },
  {
    "name": "odnoklassniki-square",
    "icon": "fa-odnoklassniki-square fab"
  },
  {
    "name": "oil-can",
    "icon": "fa-oil-can fas"
  },
  {
    "name": "old-republic",
    "icon": "fa-old-republic fab"
  },
  {
    "name": "om",
    "icon": "fa-om fas"
  },
  {
    "name": "opencart",
    "icon": "fa-opencart fab"
  },
  {
    "name": "openid",
    "icon": "fa-openid fab"
  },
  {
    "name": "opera",
    "icon": "fa-opera fab"
  },
  {
    "name": "optin-monster",
    "icon": "fa-optin-monster fab"
  },
  {
    "name": "orcid",
    "icon": "fa-orcid fab"
  },
  {
    "name": "osi",
    "icon": "fa-osi fab"
  },
  {
    "name": "otter",
    "icon": "fa-otter fas"
  },
  {
    "name": "outdent",
    "icon": "fa-outdent fas"
  },
  {
    "name": "page4",
    "icon": "fa-page4 fab"
  },
  {
    "name": "pagelines",
    "icon": "fa-pagelines fab"
  },
  {
    "name": "pager",
    "icon": "fa-pager fas"
  },
  {
    "name": "paint-brush",
    "icon": "fa-paint-brush fas"
  },
  {
    "name": "paint-roller",
    "icon": "fa-paint-roller fas"
  },
  {
    "name": "palette",
    "icon": "fa-palette fas"
  },
  {
    "name": "palfed",
    "icon": "fa-palfed fab"
  },
  {
    "name": "pallet",
    "icon": "fa-pallet fas"
  },
  {
    "name": "paper-plane",
    "icon": "fa-paper-plane fas"
  },
  {
    "name": "paperclip",
    "icon": "fa-paperclip fas"
  },
  {
    "name": "parachute-box",
    "icon": "fa-parachute-box fas"
  },
  {
    "name": "paragraph",
    "icon": "fa-paragraph fas"
  },
  {
    "name": "parking",
    "icon": "fa-parking fas"
  },
  {
    "name": "passport",
    "icon": "fa-passport fas"
  },
  {
    "name": "pastafarianism",
    "icon": "fa-pastafarianism fas"
  },
  {
    "name": "paste",
    "icon": "fa-paste fas"
  },
  {
    "name": "patreon",
    "icon": "fa-patreon fab"
  },
  {
    "name": "pause",
    "icon": "fa-pause fas"
  },
  {
    "name": "pause-circle",
    "icon": "fa-pause-circle fas"
  },
  {
    "name": "paw",
    "icon": "fa-paw fas"
  },
  {
    "name": "paypal",
    "icon": "fa-paypal fab"
  },
  {
    "name": "peace",
    "icon": "fa-peace fas"
  },
  {
    "name": "pen",
    "icon": "fa-pen fas"
  },
  {
    "name": "pen-alt",
    "icon": "fa-pen-alt fas"
  },
  {
    "name": "pen-fancy",
    "icon": "fa-pen-fancy fas"
  },
  {
    "name": "pen-nib",
    "icon": "fa-pen-nib fas"
  },
  {
    "name": "pen-square",
    "icon": "fa-pen-square fas"
  },
  {
    "name": "pencil-alt",
    "icon": "fa-pencil-alt fas"
  },
  {
    "name": "pencil-ruler",
    "icon": "fa-pencil-ruler fas"
  },
  {
    "name": "penny-arcade",
    "icon": "fa-penny-arcade fab"
  },
  {
    "name": "people-arrows",
    "icon": "fa-people-arrows fas"
  },
  {
    "name": "people-carry",
    "icon": "fa-people-carry fas"
  },
  {
    "name": "pepper-hot",
    "icon": "fa-pepper-hot fas"
  },
  {
    "name": "perbyte",
    "icon": "fa-perbyte fab"
  },
  {
    "name": "percent",
    "icon": "fa-percent fas"
  },
  {
    "name": "percentage",
    "icon": "fa-percentage fas"
  },
  {
    "name": "periscope",
    "icon": "fa-periscope fab"
  },
  {
    "name": "person-booth",
    "icon": "fa-person-booth fas"
  },
  {
    "name": "phabricator",
    "icon": "fa-phabricator fab"
  },
  {
    "name": "phoenix-framework",
    "icon": "fa-phoenix-framework fab"
  },
  {
    "name": "phoenix-squadron",
    "icon": "fa-phoenix-squadron fab"
  },
  {
    "name": "phone",
    "icon": "fa-phone fas"
  },
  {
    "name": "phone-alt",
    "icon": "fa-phone-alt fas"
  },
  {
    "name": "phone-slash",
    "icon": "fa-phone-slash fas"
  },
  {
    "name": "phone-square",
    "icon": "fa-phone-square fas"
  },
  {
    "name": "phone-square-alt",
    "icon": "fa-phone-square-alt fas"
  },
  {
    "name": "phone-volume",
    "icon": "fa-phone-volume fas"
  },
  {
    "name": "photo-video",
    "icon": "fa-photo-video fas"
  },
  {
    "name": "php",
    "icon": "fa-php fab"
  },
  {
    "name": "pied-piper",
    "icon": "fa-pied-piper fab"
  },
  {
    "name": "pied-piper-alt",
    "icon": "fa-pied-piper-alt fab"
  },
  {
    "name": "pied-piper-hat",
    "icon": "fa-pied-piper-hat fab"
  },
  {
    "name": "pied-piper-pp",
    "icon": "fa-pied-piper-pp fab"
  },
  {
    "name": "pied-piper-square",
    "icon": "fa-pied-piper-square fab"
  },
  {
    "name": "piggy-bank",
    "icon": "fa-piggy-bank fas"
  },
  {
    "name": "pills",
    "icon": "fa-pills fas"
  },
  {
    "name": "pinterest",
    "icon": "fa-pinterest fab"
  },
  {
    "name": "pinterest-p",
    "icon": "fa-pinterest-p fab"
  },
  {
    "name": "pinterest-square",
    "icon": "fa-pinterest-square fab"
  },
  {
    "name": "pizza-slice",
    "icon": "fa-pizza-slice fas"
  },
  {
    "name": "place-of-worship",
    "icon": "fa-place-of-worship fas"
  },
  {
    "name": "plane",
    "icon": "fa-plane fas"
  },
  {
    "name": "plane-arrival",
    "icon": "fa-plane-arrival fas"
  },
  {
    "name": "plane-departure",
    "icon": "fa-plane-departure fas"
  },
  {
    "name": "plane-slash",
    "icon": "fa-plane-slash fas"
  },
  {
    "name": "play",
    "icon": "fa-play fas"
  },
  {
    "name": "play-circle",
    "icon": "fa-play-circle fas"
  },
  {
    "name": "playstation",
    "icon": "fa-playstation fab"
  },
  {
    "name": "plug",
    "icon": "fa-plug fas"
  },
  {
    "name": "plus",
    "icon": "fa-plus fas"
  },
  {
    "name": "plus-circle",
    "icon": "fa-plus-circle fas"
  },
  {
    "name": "plus-square",
    "icon": "fa-plus-square fas"
  },
  {
    "name": "podcast",
    "icon": "fa-podcast fas"
  },
  {
    "name": "poll",
    "icon": "fa-poll fas"
  },
  {
    "name": "poll-h",
    "icon": "fa-poll-h fas"
  },
  {
    "name": "poo",
    "icon": "fa-poo fas"
  },
  {
    "name": "poo-storm",
    "icon": "fa-poo-storm fas"
  },
  {
    "name": "poop",
    "icon": "fa-poop fas"
  },
  {
    "name": "portrait",
    "icon": "fa-portrait fas"
  },
  {
    "name": "pound-sign",
    "icon": "fa-pound-sign fas"
  },
  {
    "name": "power-off",
    "icon": "fa-power-off fas"
  },
  {
    "name": "pray",
    "icon": "fa-pray fas"
  },
  {
    "name": "praying-hands",
    "icon": "fa-praying-hands fas"
  },
  {
    "name": "prescription",
    "icon": "fa-prescription fas"
  },
  {
    "name": "prescription-bottle",
    "icon": "fa-prescription-bottle fas"
  },
  {
    "name": "prescription-bottle-alt",
    "icon": "fa-prescription-bottle-alt fas"
  },
  {
    "name": "print",
    "icon": "fa-print fas"
  },
  {
    "name": "procedures",
    "icon": "fa-procedures fas"
  },
  {
    "name": "product-hunt",
    "icon": "fa-product-hunt fab"
  },
  {
    "name": "project-diagram",
    "icon": "fa-project-diagram fas"
  },
  {
    "name": "pump-medical",
    "icon": "fa-pump-medical fas"
  },
  {
    "name": "pump-soap",
    "icon": "fa-pump-soap fas"
  },
  {
    "name": "pushed",
    "icon": "fa-pushed fab"
  },
  {
    "name": "puzzle-piece",
    "icon": "fa-puzzle-piece fas"
  },
  {
    "name": "python",
    "icon": "fa-python fab"
  },
  {
    "name": "qq",
    "icon": "fa-qq fab"
  },
  {
    "name": "qrcode",
    "icon": "fa-qrcode fas"
  },
  {
    "name": "question",
    "icon": "fa-question fas"
  },
  {
    "name": "question-circle",
    "icon": "fa-question-circle fas"
  },
  {
    "name": "quidditch",
    "icon": "fa-quidditch fas"
  },
  {
    "name": "quinscape",
    "icon": "fa-quinscape fab"
  },
  {
    "name": "quora",
    "icon": "fa-quora fab"
  },
  {
    "name": "quote-left",
    "icon": "fa-quote-left fas"
  },
  {
    "name": "quote-right",
    "icon": "fa-quote-right fas"
  },
  {
    "name": "quran",
    "icon": "fa-quran fas"
  },
  {
    "name": "r-project",
    "icon": "fa-r-project fab"
  },
  {
    "name": "radiation",
    "icon": "fa-radiation fas"
  },
  {
    "name": "radiation-alt",
    "icon": "fa-radiation-alt fas"
  },
  {
    "name": "rainbow",
    "icon": "fa-rainbow fas"
  },
  {
    "name": "random",
    "icon": "fa-random fas"
  },
  {
    "name": "raspberry-pi",
    "icon": "fa-raspberry-pi fab"
  },
  {
    "name": "ravelry",
    "icon": "fa-ravelry fab"
  },
  {
    "name": "react",
    "icon": "fa-react fab"
  },
  {
    "name": "reacteurope",
    "icon": "fa-reacteurope fab"
  },
  {
    "name": "readme",
    "icon": "fa-readme fab"
  },
  {
    "name": "rebel",
    "icon": "fa-rebel fab"
  },
  {
    "name": "receipt",
    "icon": "fa-receipt fas"
  },
  {
    "name": "record-vinyl",
    "icon": "fa-record-vinyl fas"
  },
  {
    "name": "recycle",
    "icon": "fa-recycle fas"
  },
  {
    "name": "red-river",
    "icon": "fa-red-river fab"
  },
  {
    "name": "reddit",
    "icon": "fa-reddit fab"
  },
  {
    "name": "reddit-alien",
    "icon": "fa-reddit-alien fab"
  },
  {
    "name": "reddit-square",
    "icon": "fa-reddit-square fab"
  },
  {
    "name": "redhat",
    "icon": "fa-redhat fab"
  },
  {
    "name": "redo",
    "icon": "fa-redo fas"
  },
  {
    "name": "redo-alt",
    "icon": "fa-redo-alt fas"
  },
  {
    "name": "registered",
    "icon": "fa-registered fas"
  },
  {
    "name": "remove-format",
    "icon": "fa-remove-format fas"
  },
  {
    "name": "renren",
    "icon": "fa-renren fab"
  },
  {
    "name": "reply",
    "icon": "fa-reply fas"
  },
  {
    "name": "reply-all",
    "icon": "fa-reply-all fas"
  },
  {
    "name": "replyd",
    "icon": "fa-replyd fab"
  },
  {
    "name": "republican",
    "icon": "fa-republican fas"
  },
  {
    "name": "researchgate",
    "icon": "fa-researchgate fab"
  },
  {
    "name": "resolving",
    "icon": "fa-resolving fab"
  },
  {
    "name": "restroom",
    "icon": "fa-restroom fas"
  },
  {
    "name": "retweet",
    "icon": "fa-retweet fas"
  },
  {
    "name": "rev",
    "icon": "fa-rev fab"
  },
  {
    "name": "ribbon",
    "icon": "fa-ribbon fas"
  },
  {
    "name": "ring",
    "icon": "fa-ring fas"
  },
  {
    "name": "road",
    "icon": "fa-road fas"
  },
  {
    "name": "robot",
    "icon": "fa-robot fas"
  },
  {
    "name": "rocket",
    "icon": "fa-rocket fas"
  },
  {
    "name": "rocketchat",
    "icon": "fa-rocketchat fab"
  },
  {
    "name": "rockrms",
    "icon": "fa-rockrms fab"
  },
  {
    "name": "route",
    "icon": "fa-route fas"
  },
  {
    "name": "rss",
    "icon": "fa-rss fas"
  },
  {
    "name": "rss-square",
    "icon": "fa-rss-square fas"
  },
  {
    "name": "ruble-sign",
    "icon": "fa-ruble-sign fas"
  },
  {
    "name": "ruler",
    "icon": "fa-ruler fas"
  },
  {
    "name": "ruler-combined",
    "icon": "fa-ruler-combined fas"
  },
  {
    "name": "ruler-horizontal",
    "icon": "fa-ruler-horizontal fas"
  },
  {
    "name": "ruler-vertical",
    "icon": "fa-ruler-vertical fas"
  },
  {
    "name": "running",
    "icon": "fa-running fas"
  },
  {
    "name": "rupee-sign",
    "icon": "fa-rupee-sign fas"
  },
  {
    "name": "rust",
    "icon": "fa-rust fab"
  },
  {
    "name": "sad-cry",
    "icon": "fa-sad-cry fas"
  },
  {
    "name": "sad-tear",
    "icon": "fa-sad-tear fas"
  },
  {
    "name": "safari",
    "icon": "fa-safari fab"
  },
  {
    "name": "salesforce",
    "icon": "fa-salesforce fab"
  },
  {
    "name": "sass",
    "icon": "fa-sass fab"
  },
  {
    "name": "satellite",
    "icon": "fa-satellite fas"
  },
  {
    "name": "satellite-dish",
    "icon": "fa-satellite-dish fas"
  },
  {
    "name": "save",
    "icon": "fa-save fas"
  },
  {
    "name": "schlix",
    "icon": "fa-schlix fab"
  },
  {
    "name": "school",
    "icon": "fa-school fas"
  },
  {
    "name": "screwdriver",
    "icon": "fa-screwdriver fas"
  },
  {
    "name": "scribd",
    "icon": "fa-scribd fab"
  },
  {
    "name": "scroll",
    "icon": "fa-scroll fas"
  },
  {
    "name": "sd-card",
    "icon": "fa-sd-card fas"
  },
  {
    "name": "search",
    "icon": "fa-search fas"
  },
  {
    "name": "search-dollar",
    "icon": "fa-search-dollar fas"
  },
  {
    "name": "search-location",
    "icon": "fa-search-location fas"
  },
  {
    "name": "search-minus",
    "icon": "fa-search-minus fas"
  },
  {
    "name": "search-plus",
    "icon": "fa-search-plus fas"
  },
  {
    "name": "searchengin",
    "icon": "fa-searchengin fab"
  },
  {
    "name": "seedling",
    "icon": "fa-seedling fas"
  },
  {
    "name": "sellcast",
    "icon": "fa-sellcast fab"
  },
  {
    "name": "sellsy",
    "icon": "fa-sellsy fab"
  },
  {
    "name": "server",
    "icon": "fa-server fas"
  },
  {
    "name": "servicestack",
    "icon": "fa-servicestack fab"
  },
  {
    "name": "shapes",
    "icon": "fa-shapes fas"
  },
  {
    "name": "share",
    "icon": "fa-share fas"
  },
  {
    "name": "share-alt",
    "icon": "fa-share-alt fas"
  },
  {
    "name": "share-alt-square",
    "icon": "fa-share-alt-square fas"
  },
  {
    "name": "share-square",
    "icon": "fa-share-square fas"
  },
  {
    "name": "shekel-sign",
    "icon": "fa-shekel-sign fas"
  },
  {
    "name": "shield-alt",
    "icon": "fa-shield-alt fas"
  },
  {
    "name": "shield-virus",
    "icon": "fa-shield-virus fas"
  },
  {
    "name": "ship",
    "icon": "fa-ship fas"
  },
  {
    "name": "shipping-fast",
    "icon": "fa-shipping-fast fas"
  },
  {
    "name": "shirtsinbulk",
    "icon": "fa-shirtsinbulk fab"
  },
  {
    "name": "shoe-prints",
    "icon": "fa-shoe-prints fas"
  },
  {
    "name": "shopify",
    "icon": "fa-shopify fab"
  },
  {
    "name": "shopping-bag",
    "icon": "fa-shopping-bag fas"
  },
  {
    "name": "shopping-basket",
    "icon": "fa-shopping-basket fas"
  },
  {
    "name": "shopping-cart",
    "icon": "fa-shopping-cart fas"
  },
  {
    "name": "shopware",
    "icon": "fa-shopware fab"
  },
  {
    "name": "shower",
    "icon": "fa-shower fas"
  },
  {
    "name": "shuttle-van",
    "icon": "fa-shuttle-van fas"
  },
  {
    "name": "sign",
    "icon": "fa-sign fas"
  },
  {
    "name": "sign-in-alt",
    "icon": "fa-sign-in-alt fas"
  },
  {
    "name": "sign-language",
    "icon": "fa-sign-language fas"
  },
  {
    "name": "sign-out-alt",
    "icon": "fa-sign-out-alt fas"
  },
  {
    "name": "signal",
    "icon": "fa-signal fas"
  },
  {
    "name": "signature",
    "icon": "fa-signature fas"
  },
  {
    "name": "sim-card",
    "icon": "fa-sim-card fas"
  },
  {
    "name": "simplybuilt",
    "icon": "fa-simplybuilt fab"
  },
  {
    "name": "sink",
    "icon": "fa-sink fas"
  },
  {
    "name": "sistrix",
    "icon": "fa-sistrix fab"
  },
  {
    "name": "sitemap",
    "icon": "fa-sitemap fas"
  },
  {
    "name": "sith",
    "icon": "fa-sith fab"
  },
  {
    "name": "skating",
    "icon": "fa-skating fas"
  },
  {
    "name": "sketch",
    "icon": "fa-sketch fab"
  },
  {
    "name": "skiing",
    "icon": "fa-skiing fas"
  },
  {
    "name": "skiing-nordic",
    "icon": "fa-skiing-nordic fas"
  },
  {
    "name": "skull",
    "icon": "fa-skull fas"
  },
  {
    "name": "skull-crossbones",
    "icon": "fa-skull-crossbones fas"
  },
  {
    "name": "skyatlas",
    "icon": "fa-skyatlas fab"
  },
  {
    "name": "skype",
    "icon": "fa-skype fab"
  },
  {
    "name": "slack",
    "icon": "fa-slack fab"
  },
  {
    "name": "slack-hash",
    "icon": "fa-slack-hash fab"
  },
  {
    "name": "slash",
    "icon": "fa-slash fas"
  },
  {
    "name": "sleigh",
    "icon": "fa-sleigh fas"
  },
  {
    "name": "sliders-h",
    "icon": "fa-sliders-h fas"
  },
  {
    "name": "slideshare",
    "icon": "fa-slideshare fab"
  },
  {
    "name": "smile",
    "icon": "fa-smile fas"
  },
  {
    "name": "smile-beam",
    "icon": "fa-smile-beam fas"
  },
  {
    "name": "smile-wink",
    "icon": "fa-smile-wink fas"
  },
  {
    "name": "smog",
    "icon": "fa-smog fas"
  },
  {
    "name": "smoking",
    "icon": "fa-smoking fas"
  },
  {
    "name": "smoking-ban",
    "icon": "fa-smoking-ban fas"
  },
  {
    "name": "sms",
    "icon": "fa-sms fas"
  },
  {
    "name": "snapchat",
    "icon": "fa-snapchat fab"
  },
  {
    "name": "snapchat-ghost",
    "icon": "fa-snapchat-ghost fab"
  },
  {
    "name": "snapchat-square",
    "icon": "fa-snapchat-square fab"
  },
  {
    "name": "snowboarding",
    "icon": "fa-snowboarding fas"
  },
  {
    "name": "snowflake",
    "icon": "fa-snowflake fas"
  },
  {
    "name": "snowman",
    "icon": "fa-snowman fas"
  },
  {
    "name": "snowplow",
    "icon": "fa-snowplow fas"
  },
  {
    "name": "soap",
    "icon": "fa-soap fas"
  },
  {
    "name": "socks",
    "icon": "fa-socks fas"
  },
  {
    "name": "solar-panel",
    "icon": "fa-solar-panel fas"
  },
  {
    "name": "sort",
    "icon": "fa-sort fas"
  },
  {
    "name": "sort-alpha-down",
    "icon": "fa-sort-alpha-down fas"
  },
  {
    "name": "sort-alpha-down-alt",
    "icon": "fa-sort-alpha-down-alt fas"
  },
  {
    "name": "sort-alpha-up",
    "icon": "fa-sort-alpha-up fas"
  },
  {
    "name": "sort-alpha-up-alt",
    "icon": "fa-sort-alpha-up-alt fas"
  },
  {
    "name": "sort-amount-down",
    "icon": "fa-sort-amount-down fas"
  },
  {
    "name": "sort-amount-down-alt",
    "icon": "fa-sort-amount-down-alt fas"
  },
  {
    "name": "sort-amount-up",
    "icon": "fa-sort-amount-up fas"
  },
  {
    "name": "sort-amount-up-alt",
    "icon": "fa-sort-amount-up-alt fas"
  },
  {
    "name": "sort-down",
    "icon": "fa-sort-down fas"
  },
  {
    "name": "sort-numeric-down",
    "icon": "fa-sort-numeric-down fas"
  },
  {
    "name": "sort-numeric-down-alt",
    "icon": "fa-sort-numeric-down-alt fas"
  },
  {
    "name": "sort-numeric-up",
    "icon": "fa-sort-numeric-up fas"
  },
  {
    "name": "sort-numeric-up-alt",
    "icon": "fa-sort-numeric-up-alt fas"
  },
  {
    "name": "sort-up",
    "icon": "fa-sort-up fas"
  },
  {
    "name": "soundcloud",
    "icon": "fa-soundcloud fab"
  },
  {
    "name": "sourcetree",
    "icon": "fa-sourcetree fab"
  },
  {
    "name": "spa",
    "icon": "fa-spa fas"
  },
  {
    "name": "space-shuttle",
    "icon": "fa-space-shuttle fas"
  },
  {
    "name": "speakap",
    "icon": "fa-speakap fab"
  },
  {
    "name": "speaker-deck",
    "icon": "fa-speaker-deck fab"
  },
  {
    "name": "spell-check",
    "icon": "fa-spell-check fas"
  },
  {
    "name": "spider",
    "icon": "fa-spider fas"
  },
  {
    "name": "spinner",
    "icon": "fa-spinner fas"
  },
  {
    "name": "splotch",
    "icon": "fa-splotch fas"
  },
  {
    "name": "spotify",
    "icon": "fa-spotify fab"
  },
  {
    "name": "spray-can",
    "icon": "fa-spray-can fas"
  },
  {
    "name": "square",
    "icon": "fa-square fas"
  },
  {
    "name": "square-full",
    "icon": "fa-square-full fas"
  },
  {
    "name": "square-root-alt",
    "icon": "fa-square-root-alt fas"
  },
  {
    "name": "squarespace",
    "icon": "fa-squarespace fab"
  },
  {
    "name": "stack-exchange",
    "icon": "fa-stack-exchange fab"
  },
  {
    "name": "stack-overflow",
    "icon": "fa-stack-overflow fab"
  },
  {
    "name": "stackpath",
    "icon": "fa-stackpath fab"
  },
  {
    "name": "stamp",
    "icon": "fa-stamp fas"
  },
  {
    "name": "star",
    "icon": "fa-star fas"
  },
  {
    "name": "star-and-crescent",
    "icon": "fa-star-and-crescent fas"
  },
  {
    "name": "star-half",
    "icon": "fa-star-half fas"
  },
  {
    "name": "star-half-alt",
    "icon": "fa-star-half-alt fas"
  },
  {
    "name": "star-of-david",
    "icon": "fa-star-of-david fas"
  },
  {
    "name": "star-of-life",
    "icon": "fa-star-of-life fas"
  },
  {
    "name": "staylinked",
    "icon": "fa-staylinked fab"
  },
  {
    "name": "steam",
    "icon": "fa-steam fab"
  },
  {
    "name": "steam-square",
    "icon": "fa-steam-square fab"
  },
  {
    "name": "steam-symbol",
    "icon": "fa-steam-symbol fab"
  },
  {
    "name": "step-backward",
    "icon": "fa-step-backward fas"
  },
  {
    "name": "step-forward",
    "icon": "fa-step-forward fas"
  },
  {
    "name": "stethoscope",
    "icon": "fa-stethoscope fas"
  },
  {
    "name": "sticker-mule",
    "icon": "fa-sticker-mule fab"
  },
  {
    "name": "sticky-note",
    "icon": "fa-sticky-note fas"
  },
  {
    "name": "stop",
    "icon": "fa-stop fas"
  },
  {
    "name": "stop-circle",
    "icon": "fa-stop-circle fas"
  },
  {
    "name": "stopwatch",
    "icon": "fa-stopwatch fas"
  },
  {
    "name": "stopwatch-20",
    "icon": "fa-stopwatch-20 fas"
  },
  {
    "name": "store",
    "icon": "fa-store fas"
  },
  {
    "name": "store-alt",
    "icon": "fa-store-alt fas"
  },
  {
    "name": "store-alt-slash",
    "icon": "fa-store-alt-slash fas"
  },
  {
    "name": "store-slash",
    "icon": "fa-store-slash fas"
  },
  {
    "name": "strava",
    "icon": "fa-strava fab"
  },
  {
    "name": "stream",
    "icon": "fa-stream fas"
  },
  {
    "name": "street-view",
    "icon": "fa-street-view fas"
  },
  {
    "name": "strikethrough",
    "icon": "fa-strikethrough fas"
  },
  {
    "name": "stripe",
    "icon": "fa-stripe fab"
  },
  {
    "name": "stripe-s",
    "icon": "fa-stripe-s fab"
  },
  {
    "name": "stroopwafel",
    "icon": "fa-stroopwafel fas"
  },
  {
    "name": "studiovinari",
    "icon": "fa-studiovinari fab"
  },
  {
    "name": "stumbleupon",
    "icon": "fa-stumbleupon fab"
  },
  {
    "name": "stumbleupon-circle",
    "icon": "fa-stumbleupon-circle fab"
  },
  {
    "name": "subscript",
    "icon": "fa-subscript fas"
  },
  {
    "name": "subway",
    "icon": "fa-subway fas"
  },
  {
    "name": "suitcase",
    "icon": "fa-suitcase fas"
  },
  {
    "name": "suitcase-rolling",
    "icon": "fa-suitcase-rolling fas"
  },
  {
    "name": "sun",
    "icon": "fa-sun fas"
  },
  {
    "name": "superpowers",
    "icon": "fa-superpowers fab"
  },
  {
    "name": "superscript",
    "icon": "fa-superscript fas"
  },
  {
    "name": "supple",
    "icon": "fa-supple fab"
  },
  {
    "name": "surprise",
    "icon": "fa-surprise fas"
  },
  {
    "name": "suse",
    "icon": "fa-suse fab"
  },
  {
    "name": "swatchbook",
    "icon": "fa-swatchbook fas"
  },
  {
    "name": "swift",
    "icon": "fa-swift fab"
  },
  {
    "name": "swimmer",
    "icon": "fa-swimmer fas"
  },
  {
    "name": "swimming-pool",
    "icon": "fa-swimming-pool fas"
  },
  {
    "name": "symfony",
    "icon": "fa-symfony fab"
  },
  {
    "name": "synagogue",
    "icon": "fa-synagogue fas"
  },
  {
    "name": "sync",
    "icon": "fa-sync fas"
  },
  {
    "name": "sync-alt",
    "icon": "fa-sync-alt fas"
  },
  {
    "name": "syringe",
    "icon": "fa-syringe fas"
  },
  {
    "name": "table",
    "icon": "fa-table fas"
  },
  {
    "name": "table-tennis",
    "icon": "fa-table-tennis fas"
  },
  {
    "name": "tablet",
    "icon": "fa-tablet fas"
  },
  {
    "name": "tablet-alt",
    "icon": "fa-tablet-alt fas"
  },
  {
    "name": "tablets",
    "icon": "fa-tablets fas"
  },
  {
    "name": "tachometer-alt",
    "icon": "fa-tachometer-alt fas"
  },
  {
    "name": "tag",
    "icon": "fa-tag fas"
  },
  {
    "name": "tags",
    "icon": "fa-tags fas"
  },
  {
    "name": "tape",
    "icon": "fa-tape fas"
  },
  {
    "name": "tasks",
    "icon": "fa-tasks fas"
  },
  {
    "name": "taxi",
    "icon": "fa-taxi fas"
  },
  {
    "name": "teamspeak",
    "icon": "fa-teamspeak fab"
  },
  {
    "name": "teeth",
    "icon": "fa-teeth fas"
  },
  {
    "name": "teeth-open",
    "icon": "fa-teeth-open fas"
  },
  {
    "name": "telegram",
    "icon": "fa-telegram fab"
  },
  {
    "name": "telegram-plane",
    "icon": "fa-telegram-plane fab"
  },
  {
    "name": "temperature-high",
    "icon": "fa-temperature-high fas"
  },
  {
    "name": "temperature-low",
    "icon": "fa-temperature-low fas"
  },
  {
    "name": "tencent-weibo",
    "icon": "fa-tencent-weibo fab"
  },
  {
    "name": "tenge",
    "icon": "fa-tenge fas"
  },
  {
    "name": "terminal",
    "icon": "fa-terminal fas"
  },
  {
    "name": "text-height",
    "icon": "fa-text-height fas"
  },
  {
    "name": "text-width",
    "icon": "fa-text-width fas"
  },
  {
    "name": "th",
    "icon": "fa-th fas"
  },
  {
    "name": "th-large",
    "icon": "fa-th-large fas"
  },
  {
    "name": "th-list",
    "icon": "fa-th-list fas"
  },
  {
    "name": "the-red-yeti",
    "icon": "fa-the-red-yeti fab"
  },
  {
    "name": "theater-masks",
    "icon": "fa-theater-masks fas"
  },
  {
    "name": "themeco",
    "icon": "fa-themeco fab"
  },
  {
    "name": "themeisle",
    "icon": "fa-themeisle fab"
  },
  {
    "name": "thermometer",
    "icon": "fa-thermometer fas"
  },
  {
    "name": "thermometer-empty",
    "icon": "fa-thermometer-empty fas"
  },
  {
    "name": "thermometer-full",
    "icon": "fa-thermometer-full fas"
  },
  {
    "name": "thermometer-half",
    "icon": "fa-thermometer-half fas"
  },
  {
    "name": "thermometer-quarter",
    "icon": "fa-thermometer-quarter fas"
  },
  {
    "name": "thermometer-three-quarters",
    "icon": "fa-thermometer-three-quarters fas"
  },
  {
    "name": "think-peaks",
    "icon": "fa-think-peaks fab"
  },
  {
    "name": "thumbs-down",
    "icon": "fa-thumbs-down fas"
  },
  {
    "name": "thumbs-up",
    "icon": "fa-thumbs-up fas"
  },
  {
    "name": "thumbtack",
    "icon": "fa-thumbtack fas"
  },
  {
    "name": "ticket-alt",
    "icon": "fa-ticket-alt fas"
  },
  {
    "name": "tiktok",
    "icon": "fa-tiktok fab"
  },
  {
    "name": "times",
    "icon": "fa-times fas"
  },
  {
    "name": "times-circle",
    "icon": "fa-times-circle fas"
  },
  {
    "name": "tint",
    "icon": "fa-tint fas"
  },
  {
    "name": "tint-slash",
    "icon": "fa-tint-slash fas"
  },
  {
    "name": "tired",
    "icon": "fa-tired fas"
  },
  {
    "name": "toggle-off",
    "icon": "fa-toggle-off fas"
  },
  {
    "name": "toggle-on",
    "icon": "fa-toggle-on fas"
  },
  {
    "name": "toilet",
    "icon": "fa-toilet fas"
  },
  {
    "name": "toilet-paper",
    "icon": "fa-toilet-paper fas"
  },
  {
    "name": "toilet-paper-slash",
    "icon": "fa-toilet-paper-slash fas"
  },
  {
    "name": "toolbox",
    "icon": "fa-toolbox fas"
  },
  {
    "name": "tools",
    "icon": "fa-tools fas"
  },
  {
    "name": "tooth",
    "icon": "fa-tooth fas"
  },
  {
    "name": "torah",
    "icon": "fa-torah fas"
  },
  {
    "name": "torii-gate",
    "icon": "fa-torii-gate fas"
  },
  {
    "name": "tractor",
    "icon": "fa-tractor fas"
  },
  {
    "name": "trade-federation",
    "icon": "fa-trade-federation fab"
  },
  {
    "name": "trademark",
    "icon": "fa-trademark fas"
  },
  {
    "name": "traffic-light",
    "icon": "fa-traffic-light fas"
  },
  {
    "name": "trailer",
    "icon": "fa-trailer fas"
  },
  {
    "name": "train",
    "icon": "fa-train fas"
  },
  {
    "name": "tram",
    "icon": "fa-tram fas"
  },
  {
    "name": "transgender",
    "icon": "fa-transgender fas"
  },
  {
    "name": "transgender-alt",
    "icon": "fa-transgender-alt fas"
  },
  {
    "name": "trash",
    "icon": "fa-trash fas"
  },
  {
    "name": "trash-alt",
    "icon": "fa-trash-alt fas"
  },
  {
    "name": "trash-restore",
    "icon": "fa-trash-restore fas"
  },
  {
    "name": "trash-restore-alt",
    "icon": "fa-trash-restore-alt fas"
  },
  {
    "name": "tree",
    "icon": "fa-tree fas"
  },
  {
    "name": "trello",
    "icon": "fa-trello fab"
  },
  {
    "name": "trophy",
    "icon": "fa-trophy fas"
  },
  {
    "name": "truck",
    "icon": "fa-truck fas"
  },
  {
    "name": "truck-loading",
    "icon": "fa-truck-loading fas"
  },
  {
    "name": "truck-monster",
    "icon": "fa-truck-monster fas"
  },
  {
    "name": "truck-moving",
    "icon": "fa-truck-moving fas"
  },
  {
    "name": "truck-pickup",
    "icon": "fa-truck-pickup fas"
  },
  {
    "name": "tshirt",
    "icon": "fa-tshirt fas"
  },
  {
    "name": "tty",
    "icon": "fa-tty fas"
  },
  {
    "name": "tumblr",
    "icon": "fa-tumblr fab"
  },
  {
    "name": "tumblr-square",
    "icon": "fa-tumblr-square fab"
  },
  {
    "name": "tv",
    "icon": "fa-tv fas"
  },
  {
    "name": "twitch",
    "icon": "fa-twitch fab"
  },
  {
    "name": "twitter",
    "icon": "fa-twitter fab"
  },
  {
    "name": "twitter-square",
    "icon": "fa-twitter-square fab"
  },
  {
    "name": "typo3",
    "icon": "fa-typo3 fab"
  },
  {
    "name": "uber",
    "icon": "fa-uber fab"
  },
  {
    "name": "ubuntu",
    "icon": "fa-ubuntu fab"
  },
  {
    "name": "uikit",
    "icon": "fa-uikit fab"
  },
  {
    "name": "umbraco",
    "icon": "fa-umbraco fab"
  },
  {
    "name": "umbrella",
    "icon": "fa-umbrella fas"
  },
  {
    "name": "umbrella-beach",
    "icon": "fa-umbrella-beach fas"
  },
  {
    "name": "uncharted",
    "icon": "fa-uncharted fab"
  },
  {
    "name": "underline",
    "icon": "fa-underline fas"
  },
  {
    "name": "undo",
    "icon": "fa-undo fas"
  },
  {
    "name": "undo-alt",
    "icon": "fa-undo-alt fas"
  },
  {
    "name": "uniregistry",
    "icon": "fa-uniregistry fab"
  },
  {
    "name": "unity",
    "icon": "fa-unity fab"
  },
  {
    "name": "universal-access",
    "icon": "fa-universal-access fas"
  },
  {
    "name": "university",
    "icon": "fa-university fas"
  },
  {
    "name": "unlink",
    "icon": "fa-unlink fas"
  },
  {
    "name": "unlock",
    "icon": "fa-unlock fas"
  },
  {
    "name": "unlock-alt",
    "icon": "fa-unlock-alt fas"
  },
  {
    "name": "unsplash",
    "icon": "fa-unsplash fab"
  },
  {
    "name": "untappd",
    "icon": "fa-untappd fab"
  },
  {
    "name": "upload",
    "icon": "fa-upload fas"
  },
  {
    "name": "ups",
    "icon": "fa-ups fab"
  },
  {
    "name": "usb",
    "icon": "fa-usb fab"
  },
  {
    "name": "user",
    "icon": "fa-user fas"
  },
  {
    "name": "user-alt",
    "icon": "fa-user-alt fas"
  },
  {
    "name": "user-alt-slash",
    "icon": "fa-user-alt-slash fas"
  },
  {
    "name": "user-astronaut",
    "icon": "fa-user-astronaut fas"
  },
  {
    "name": "user-check",
    "icon": "fa-user-check fas"
  },
  {
    "name": "user-circle",
    "icon": "fa-user-circle fas"
  },
  {
    "name": "user-clock",
    "icon": "fa-user-clock fas"
  },
  {
    "name": "user-cog",
    "icon": "fa-user-cog fas"
  },
  {
    "name": "user-edit",
    "icon": "fa-user-edit fas"
  },
  {
    "name": "user-friends",
    "icon": "fa-user-friends fas"
  },
  {
    "name": "user-graduate",
    "icon": "fa-user-graduate fas"
  },
  {
    "name": "user-injured",
    "icon": "fa-user-injured fas"
  },
  {
    "name": "user-lock",
    "icon": "fa-user-lock fas"
  },
  {
    "name": "user-md",
    "icon": "fa-user-md fas"
  },
  {
    "name": "user-minus",
    "icon": "fa-user-minus fas"
  },
  {
    "name": "user-ninja",
    "icon": "fa-user-ninja fas"
  },
  {
    "name": "user-nurse",
    "icon": "fa-user-nurse fas"
  },
  {
    "name": "user-plus",
    "icon": "fa-user-plus fas"
  },
  {
    "name": "user-secret",
    "icon": "fa-user-secret fas"
  },
  {
    "name": "user-shield",
    "icon": "fa-user-shield fas"
  },
  {
    "name": "user-slash",
    "icon": "fa-user-slash fas"
  },
  {
    "name": "user-tag",
    "icon": "fa-user-tag fas"
  },
  {
    "name": "user-tie",
    "icon": "fa-user-tie fas"
  },
  {
    "name": "user-times",
    "icon": "fa-user-times fas"
  },
  {
    "name": "users",
    "icon": "fa-users fas"
  },
  {
    "name": "users-cog",
    "icon": "fa-users-cog fas"
  },
  {
    "name": "users-slash",
    "icon": "fa-users-slash fas"
  },
  {
    "name": "usps",
    "icon": "fa-usps fab"
  },
  {
    "name": "ussunnah",
    "icon": "fa-ussunnah fab"
  },
  {
    "name": "utensil-spoon",
    "icon": "fa-utensil-spoon fas"
  },
  {
    "name": "utensils",
    "icon": "fa-utensils fas"
  },
  {
    "name": "vaadin",
    "icon": "fa-vaadin fab"
  },
  {
    "name": "vector-square",
    "icon": "fa-vector-square fas"
  },
  {
    "name": "venus",
    "icon": "fa-venus fas"
  },
  {
    "name": "venus-double",
    "icon": "fa-venus-double fas"
  },
  {
    "name": "venus-mars",
    "icon": "fa-venus-mars fas"
  },
  {
    "name": "vest",
    "icon": "fa-vest fas"
  },
  {
    "name": "vest-patches",
    "icon": "fa-vest-patches fas"
  },
  {
    "name": "viacoin",
    "icon": "fa-viacoin fab"
  },
  {
    "name": "viadeo",
    "icon": "fa-viadeo fab"
  },
  {
    "name": "viadeo-square",
    "icon": "fa-viadeo-square fab"
  },
  {
    "name": "vial",
    "icon": "fa-vial fas"
  },
  {
    "name": "vials",
    "icon": "fa-vials fas"
  },
  {
    "name": "viber",
    "icon": "fa-viber fab"
  },
  {
    "name": "video",
    "icon": "fa-video fas"
  },
  {
    "name": "video-slash",
    "icon": "fa-video-slash fas"
  },
  {
    "name": "vihara",
    "icon": "fa-vihara fas"
  },
  {
    "name": "vimeo",
    "icon": "fa-vimeo fab"
  },
  {
    "name": "vimeo-square",
    "icon": "fa-vimeo-square fab"
  },
  {
    "name": "vimeo-v",
    "icon": "fa-vimeo-v fab"
  },
  {
    "name": "vine",
    "icon": "fa-vine fab"
  },
  {
    "name": "virus",
    "icon": "fa-virus fas"
  },
  {
    "name": "virus-slash",
    "icon": "fa-virus-slash fas"
  },
  {
    "name": "viruses",
    "icon": "fa-viruses fas"
  },
  {
    "name": "vk",
    "icon": "fa-vk fab"
  },
  {
    "name": "vnv",
    "icon": "fa-vnv fab"
  },
  {
    "name": "voicemail",
    "icon": "fa-voicemail fas"
  },
  {
    "name": "volleyball-ball",
    "icon": "fa-volleyball-ball fas"
  },
  {
    "name": "volume-down",
    "icon": "fa-volume-down fas"
  },
  {
    "name": "volume-mute",
    "icon": "fa-volume-mute fas"
  },
  {
    "name": "volume-off",
    "icon": "fa-volume-off fas"
  },
  {
    "name": "volume-up",
    "icon": "fa-volume-up fas"
  },
  {
    "name": "vote-yea",
    "icon": "fa-vote-yea fas"
  },
  {
    "name": "vr-cardboard",
    "icon": "fa-vr-cardboard fas"
  },
  {
    "name": "vuejs",
    "icon": "fa-vuejs fab"
  },
  {
    "name": "walking",
    "icon": "fa-walking fas"
  },
  {
    "name": "wallet",
    "icon": "fa-wallet fas"
  },
  {
    "name": "warehouse",
    "icon": "fa-warehouse fas"
  },
  {
    "name": "watchman-monitoring",
    "icon": "fa-watchman-monitoring fab"
  },
  {
    "name": "water",
    "icon": "fa-water fas"
  },
  {
    "name": "wave-square",
    "icon": "fa-wave-square fas"
  },
  {
    "name": "waze",
    "icon": "fa-waze fab"
  },
  {
    "name": "weebly",
    "icon": "fa-weebly fab"
  },
  {
    "name": "weibo",
    "icon": "fa-weibo fab"
  },
  {
    "name": "weight",
    "icon": "fa-weight fas"
  },
  {
    "name": "weight-hanging",
    "icon": "fa-weight-hanging fas"
  },
  {
    "name": "weixin",
    "icon": "fa-weixin fab"
  },
  {
    "name": "whatsapp",
    "icon": "fa-whatsapp fab"
  },
  {
    "name": "whatsapp-square",
    "icon": "fa-whatsapp-square fab"
  },
  {
    "name": "wheelchair",
    "icon": "fa-wheelchair fas"
  },
  {
    "name": "whmcs",
    "icon": "fa-whmcs fab"
  },
  {
    "name": "wifi",
    "icon": "fa-wifi fas"
  },
  {
    "name": "wikipedia-w",
    "icon": "fa-wikipedia-w fab"
  },
  {
    "name": "wind",
    "icon": "fa-wind fas"
  },
  {
    "name": "window-close",
    "icon": "fa-window-close fas"
  },
  {
    "name": "window-maximize",
    "icon": "fa-window-maximize fas"
  },
  {
    "name": "window-minimize",
    "icon": "fa-window-minimize fas"
  },
  {
    "name": "window-restore",
    "icon": "fa-window-restore fas"
  },
  {
    "name": "windows",
    "icon": "fa-windows fab"
  },
  {
    "name": "wine-bottle",
    "icon": "fa-wine-bottle fas"
  },
  {
    "name": "wine-glass",
    "icon": "fa-wine-glass fas"
  },
  {
    "name": "wine-glass-alt",
    "icon": "fa-wine-glass-alt fas"
  },
  {
    "name": "wix",
    "icon": "fa-wix fab"
  },
  {
    "name": "wizards-of-the-coast",
    "icon": "fa-wizards-of-the-coast fab"
  },
  {
    "name": "wodu",
    "icon": "fa-wodu fab"
  },
  {
    "name": "wolf-pack-battalion",
    "icon": "fa-wolf-pack-battalion fab"
  },
  {
    "name": "won-sign",
    "icon": "fa-won-sign fas"
  },
  {
    "name": "wordpress",
    "icon": "fa-wordpress fab"
  },
  {
    "name": "wordpress-simple",
    "icon": "fa-wordpress-simple fab"
  },
  {
    "name": "wpbeginner",
    "icon": "fa-wpbeginner fab"
  },
  {
    "name": "wpexplorer",
    "icon": "fa-wpexplorer fab"
  },
  {
    "name": "wpforms",
    "icon": "fa-wpforms fab"
  },
  {
    "name": "wpressr",
    "icon": "fa-wpressr fab"
  },
  {
    "name": "wrench",
    "icon": "fa-wrench fas"
  },
  {
    "name": "x-ray",
    "icon": "fa-x-ray fas"
  },
  {
    "name": "xbox",
    "icon": "fa-xbox fab"
  },
  {
    "name": "xing",
    "icon": "fa-xing fab"
  },
  {
    "name": "xing-square",
    "icon": "fa-xing-square fab"
  },
  {
    "name": "y-combinator",
    "icon": "fa-y-combinator fab"
  },
  {
    "name": "yahoo",
    "icon": "fa-yahoo fab"
  },
  {
    "name": "yammer",
    "icon": "fa-yammer fab"
  },
  {
    "name": "yandex",
    "icon": "fa-yandex fab"
  },
  {
    "name": "yandex-international",
    "icon": "fa-yandex-international fab"
  },
  {
    "name": "yarn",
    "icon": "fa-yarn fab"
  },
  {
    "name": "yelp",
    "icon": "fa-yelp fab"
  },
  {
    "name": "yen-sign",
    "icon": "fa-yen-sign fas"
  },
  {
    "name": "yin-yang",
    "icon": "fa-yin-yang fas"
  },
  {
    "name": "yoast",
    "icon": "fa-yoast fab"
  },
  {
    "name": "youtube",
    "icon": "fa-youtube fab"
  },
  {
    "name": "youtube-square",
    "icon": "fa-youtube-square fab"
  },
  {
    "name": "zhihu",
    "icon": "fa-zhihu fab"
  }
]
